<template>
    <div class="ah-page payment-edit-page">
        <div class="page-header" id="payment-page-header" style="margin-bottom: 25px">
            <div class="ah-container">
                <div class="title-one-row">
                    <h1 v-if="form.sno">編輯請款單</h1>
                    <h1 v-else>新增請款單</h1>
                    <div>
                        <el-button type="danger" v-if="form.sno" @click="handleDelete" icon="el-icon-delete">作廢</el-button>
                        <el-button @click="handleClose" icon="el-icon-close">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" :label-position="labelPosition" label-width="200px">
            <div class="ah-container">
                <!-- 退件 -->
                <el-alert style="margin-bottom: 20px" type="error" title="退件原因：" v-if="form.sno && getReturnInfo" :closable="false">
                    <div>{{ getReturnInfo.rsn }}</div>
                    <div>{{ `${getReturnInfo.stF_NAM} ` }}{{ getReturnInfo.sdat | dateFormater("YYYY-MM-dd") }}</div>
                </el-alert>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">請款單類型</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="請款單類型">
                            <el-radio-group v-model="form.typ" @change="onTypChange" class="radio-option-cards">
                                <el-radio :label="item.key" v-for="(item, index) in paymentTypeOptions" :key="item.key" :id="'payment-add-page-type-' + index" border>
                                    <div class="icon">
                                        <i :class="`el-icon-${item.icon}`"></i>
                                    </div>
                                    <div class="title">{{ item.value }}</div>
                                    <div class="intro">
                                        {{ item.intro }}
                                        <ah-tip v-if="item.tip">{{ item.tip }}</ah-tip>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-alert v-if="form.typ == 5" type="warning" :closable="false" class="compact">領台幣做臨櫃外幣匯款，請財務部門臨櫃填寫海外匯款單。</el-alert>
                        </el-form-item>
                        <!-- 2:專案請款 -->
                        <template v-if="form.typ === 2">
                            <el-form-item prop="poo" label="專案">
                                <el-select
                                    v-model="form.poo"
                                    name="project"
                                    :placeholder="companyInfo.displayProject ? '請選擇專案' : '請輸入專案名稱關鍵字（至少兩個字）'"
                                    :no-data-text="companyInfo.displayProject ? '無專案' : '無匹配專案'"
                                    :remote="form.typ === 2"
                                    :remote-method="projectRemoteMethod"
                                    filterable
                                    clearable
                                    no-match-text="無匹配專案"
                                    class="project-select"
                                    @change="handleProjectChange"
                                    @clear="handleProjectClear"
                                    @keydown.native.capture.enter="preventIMESelect"
                                >
                                    <el-option v-for="item in projectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                                </el-select>
                            </el-form-item>
                        </template>
                        <!-- 3:特定費請款 -->
                        <template v-if="form.typ === 3">
                            <el-form-item prop="poo" label="特定費用項目">
                                <el-select
                                    v-model="form.poo"
                                    name="project"
                                    placeholder="請選擇"
                                    no-data-text="無項目"
                                    no-match-text="無匹配項目"
                                    filterable
                                    clearable
                                    class="project-select"
                                    @change="handleProjectChange"
                                    @clear="handleProjectClear"
                                    @keydown.native.capture.enter="preventIMESelect"
                                >
                                    <el-option v-for="item in specialProjectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                                </el-select>
                            </el-form-item>
                        </template>
                        <!-- 4:經常性支出項目 -->
                        <template v-if="form.typ === 4">
                            <el-form-item prop="ofeN_ITEM_SNO" label="經常性支出項目">
                                <el-select name="type" v-model="form.ofeN_ITEM_SNO" placeholder="請選擇" no-data-text="無項目" style="width: 100%" @change="handleOftenProjectChange" filterable>
                                    <el-option v-for="item in oftenProjectList" :key="item.sno" :label="item.iteM_NAM" :value="item.sno" />
                                </el-select>
                                <el-alert type="warning" style="padding: 0px 5px; margin-top: 10px" :closable="false" v-if="form.typ === 4 && currExpendAmtSpan"
                                    >金額範圍：{{ currExpendAmtSpan.min }} ~ {{ currExpendAmtSpan.max }}</el-alert
                                >
                            </el-form-item>
                        </template>
                        <!-- 6:財務單 -->
                        <template v-if="form.typ === 6">
                            <el-form-item label="歸屬項目">
                                <el-radio-group v-model="variableProjectTyp" @change="onVariableProjectTypChange">
                                    <el-radio :label="0">無<ah-tip>不歸屬到「專案」或「特定費」之費用</ah-tip></el-radio>
                                    <el-radio :label="1">特定費用項目</el-radio>
                                    <el-radio :label="2">專案</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="variableProjectTyp === 1" prop="poo" :label="getProjectTitle">
                                <el-select
                                    v-model="form.poo"
                                    name="project"
                                    placeholder="請選擇"
                                    no-data-text="無項目"
                                    no-match-text="無匹配項目"
                                    filterable
                                    clearable
                                    class="project-select"
                                    @change="handleProjectChange"
                                    @clear="handleProjectClear"
                                    @keydown.native.capture.enter="preventIMESelect"
                                >
                                    <el-option v-for="item in specialProjectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="variableProjectTyp === 2" prop="poo" :label="getProjectTitle">
                                <el-select
                                    v-model="form.poo"
                                    name="project"
                                    :placeholder="companyInfo.displayProject ? '請選擇專案' : '請輸入專案名稱關鍵字（至少兩個字）'"
                                    :no-data-text="companyInfo.displayProject ? '無專案' : '無匹配專案'"
                                    :remote="form.typ === 2 || (form.typ === 6 && variableProjectTyp === 2)"
                                    :remote-method="projectRemoteMethod"
                                    filterable
                                    clearable
                                    no-match-text="無匹配專案"
                                    class="project-select"
                                    @change="handleProjectChange"
                                    @clear="handleProjectClear"
                                    @keydown.native.capture.enter="preventIMESelect"
                                >
                                    <el-option v-for="item in projectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                                </el-select>
                            </el-form-item>
                        </template>

                        <el-form-item label="審核流程預覽" v-if="form.typ !== 6 && isShowAuditFlows">
                            <!-- 審核流程：一般、外幣 -->
                            <div v-if="form.typ === 1 || form.typ === 5">
                                <div v-if="isFullAuditFlow && auditFlowSetting">
                                    <el-table class="auditFlow-table" :data="auditFlowSetting.payoutAuditFlowSetting.settings" size="small">
                                        <el-table-column prop="" label="請款金額範圍" width="230">
                                            <template slot-scope="scope">
                                                <Money :v="scope.row.startAmount" />
                                                ~
                                                <Money :v="scope.row.endAmount" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="" label="審核流程">
                                            <template slot-scope="scope">
                                                <ahAuditFlowViewer align="left" :items="scope.row.steps" size="small" />
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-if="isFullAuditFlow === false && auditFlowSetting">
                                    <ahAuditFlowViewer
                                        v-if="auditFlowSetting.payoutAuditFlowSetting"
                                        align="left"
                                        :items="auditFlowSetting.payoutAuditFlowSetting.settings[0].steps"
                                        size="small"
                                        style="margin: 5px 0 0 0"
                                    />
                                </div>
                            </div>
                            <!-- 審核流程：專案 -->
                            <div v-if="form.typ === 2">
                                <div v-if="isFullAuditFlow && auditFlowSetting">
                                    <el-table class="auditFlow-table" :data="auditFlowSetting.projectAuditFlowSetting.settings" size="small">
                                        <el-table-column prop="" label="請款金額範圍" width="230">
                                            <template slot-scope="scope">
                                                <Money :v="scope.row.startAmount" />
                                                ~
                                                <Money :v="scope.row.endAmount" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="" label="審核流程">
                                            <template slot-scope="scope">
                                                <ahAuditFlowViewer align="left" :items="scope.row.steps" size="small" />
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-if="isFullAuditFlow === false && auditFlowSetting">
                                    <ahAuditFlowViewer
                                        v-if="auditFlowSetting.projectAuditFlowSetting"
                                        align="left"
                                        :items="auditFlowSetting.projectAuditFlowSetting.settings[0].steps"
                                        size="small"
                                        style="margin: 5px 0 0 0"
                                    />
                                </div>
                            </div>
                            <!-- 審核流程：特定費用 -->
                            <div v-if="form.typ === 3">
                                <ahAuditFlowViewer align="left" v-if="selectedProject" :items="selectedProject.auditFlowItems" size="small" style="margin: 5px 0 0 0" />
                                <div v-if="!selectedProject" style="color: #aaa; font-size: 10pt">（依所選特定費用項目）</div>
                            </div>
                            <!-- 審核流程：經常性支出 -->
                            <div v-if="form.typ === 4">
                                <ahAuditFlowViewer align="left" v-if="currOftenProjectDetail" :items="currOftenProjectDetail.auditFlowItems" size="small" style="margin: 5px 0 0 0" />
                                <div v-if="!currOftenProjectDetail" style="color: #aaa; font-size: 10pt">（依所選經常性支出）</div>
                            </div>
                        </el-form-item>
                        <el-alert v-if="!isFlowValidate" id="no-flow-error" type="error" center :closable="false" style="margin-bottom: 10px">
                            此請款金額未有審核流程，請至「設定 / 審核流程」重新設定。
                        </el-alert>
                        <div v-if="isShowAuditFlows && form.typ !== 6" style="text-align: right">
                            <el-button @click="isShowAuditFlows = false" size="mini">隱藏審核流程</el-button>
                        </div>
                    </div>
                </div>
                <div v-if="!isShowAuditFlows && form.typ !== 6" style="text-align: right; margin: -30px 0 15px 0">
                    <el-button @click="isShowAuditFlows = true" size="mini">預覽審核流程</el-button>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">請款資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="dat">
                            <template slot="label">
                                <ahRichPopInfo title="請款單日期" content="這筆支出的歸屬日，會用在「各月份營業支出分析」的計算。" :width="300">
                                    <span class="tip">請款單日期</span>
                                </ahRichPopInfo>
                            </template>
                            <el-date-picker v-model="form.dat" value-format="timestamp" type="date" placeholder="請選擇" :picker-options="expireTimeOption"> </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="nam">
                            <template slot="label">
                                <ahRichPopInfo title="請款摘要" content="這筆請款的標題，讓它精簡又清楚吧！" :width="250">
                                    <span class="tip">請款摘要</span>
                                </ahRichPopInfo>
                            </template>
                            <el-input
                                type="textarea"
                                name="nam"
                                v-model="form.nam"
                                :maxlength="150"
                                :show-word-limit="true"
                                class="ah-el-input-textarea large"
                                autosize
                                resize="none"
                                @keydown.enter.native="onNamInputKeydown($event)"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="amt">
                            <template slot="label">
                                <ahRichPopInfo title="應付總額" content="這次要付款的總金額。">
                                    <span class="tip">應付總額</span>
                                </ahRichPopInfo>
                            </template>
                            <div class="flex-wrap">
                                <ah-el-select-cny
                                    v-model="form.cny"
                                    style="max-width: 100px"
                                    width="100%"
                                    :availables="availableCny"
                                    :disabled="form.typ == 5"
                                    @change="handleCnyChange"
                                ></ah-el-select-cny>
                                <div class="amt-with-twd">
                                    <money-input name="amt" v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" @change="handleAmtChange" style="width: 250px" :suffix="form.cny" />
                                    <div v-if="form.cny !== 'TWD' && isFullAuditFlow" class="twd">約當台幣：<money :v="amtTwd" /> 元</div>
                                </div>
                                <el-alert v-if="form.paY_TO == 3" type="warning" class="compact inline" :closable="false">委外勞務超過兩萬元需繳勞務税、二代健保</el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="isFullAuditFlow && form.cny !== 'TWD'" label="即時匯率">
                            <div class="flex-wrap">
                                <money-input :value="form.paY_CNYRAT" style="width: 100px" :precision="3" :disabled="true" />
                                <el-alert type="warning" :closable="false" class="compact inline">於付款時填寫確定匯率</el-alert>
                            </div>
                        </el-form-item>
                        <!-- !!! -->
                        <el-form-item v-if="!isFullAuditFlow && form.cny !== 'TWD'" prop="paY_CNYRAT" label="匯率">
                            <div class="flex-wrap">
                                <money-input v-model="form.paY_CNYRAT" :precision="4" style="max-width: 180px" @change="onCnyRatChange" />
                                <el-button @click="applySysCnyRat(form.cny)">即時匯率</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="!isFullAuditFlow && form.cny !== 'TWD'" label="約當台幣">
                            <money-input v-model="payTwdAmt" style="width: 250px" @blur="onTwdAmtChange" suffix="TWD" />
                        </el-form-item>
                        <el-form-item prop="actualPayAmt" label="" v-show="form.paY_TO == 3">
                            <template slot="label"> 實付總額 </template>
                            <div class="flex-wrap">
                                <ah-el-select-cny v-model="form.cny" :availables="availableCny" :disabled="true"></ah-el-select-cny>
                                <div class="amt-with-twd">
                                    <money-input v-model="actualPayAmt" :precision="form.cny == 'TWD' ? 0 : 4" style="width: 250px" :disabled="true" :suffix="form.cny" />
                                    <span v-if="form.cny !== 'TWD'" class="twd">約當台幣：{{ actualPayAmtTwdDisplay }} 元</span>
                                </div>
                                <el-alert type="warning" :closable="false" class="compact inline">扣除勞務稅金、二代健保後的金額試算</el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item v-show="form.typ !== 5" label="付款方式">
                            <div class="flex-wrap">
                                <el-radio-group name="user-pay-way" v-model="form.useR_PAY_WAY" @change="handlePayWayChange">
                                    <el-radio-button :label="1" id="payment-add-page-pay-way-cash" :disabled="form.cny !== 'TWD'"> 零用現金 </el-radio-button>
                                    <el-radio-button v-if="!isFullAuditFlow" :label="3"> 銀行提現 </el-radio-button>
                                    <el-tooltip placement="top" content="申請人已選擇零用現金，若需改為銀行轉帳，請退件，由申請人填寫收款銀行資訊。" :manual="!isDisableBankTransfer">
                                        <el-radio-button :label="2" :disabled="isDisableBankTransfer"> 銀行轉帳 </el-radio-button>
                                    </el-tooltip>
                                </el-radio-group>
                                <el-alert v-if="!isFullAuditFlow" :closable="false" type="warning" class="compact inline">
                                    <template v-if="form.useR_PAY_WAY == 1">
                                        <span>即時零用現金餘額：</span>
                                        <Money :v="currCash" />
                                    </template>
                                    <template v-else>
                                        <span>如有產生匯費，請建立此單後至「財務 / 銀行匯款明細、匯費」填寫匯費金額</span>
                                    </template>
                                </el-alert>
                                <el-alert v-if="form.useR_PAY_WAY == 1" :closable="false" type="warning" class="compact inline">
                                    <span>請與公司財務確認付款方式為零用現金付款</span>
                                </el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="isShowPayBnk" prop="paY_BNK_SNO" label="轉出帳戶">
                            <ah-el-select-bank-account v-model="form.paY_BNK_SNO" document-type="payment" :cny="form.cny" hide-borrower :show-balance="this.isAuth('A02')"> </ah-el-select-bank-account>
                        </el-form-item>
                        <el-form-item prop="paY_DAT" v-if="isShowPayDat" label="預計付款日期">
                            <div class="flex-wrap">
                                <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="請選擇"></el-date-picker>
                                <el-alert v-if="companyPdatTxt || companyCdatTxt" :closable="false" class="compact inline">
                                    <div v-if="companyCdatTxt !== null" style="margin-top: 5px">本期公司請款結算日： {{ companyCdatTxt }}</div>
                                    <div v-if="companyPdatTxt !== null">本期公司請款付款日： {{ companyPdatTxt }}</div>
                                </el-alert>
                            </div>
                        </el-form-item>
                        <el-form-item prop="iteM_SNO" v-if="isShowStatementItem" label="支出項目">
                            <template slot="label"> 支出項目 <ahTip>用於財務分析的分類</ahTip> </template>
                            <ahSelectVariableStateItem v-model="form.iteM_SNO" :enableType="['payout', 'cOut', 'cOutElse']" @change="onVariableStateItemChange"></ahSelectVariableStateItem>
                        </el-form-item>
                        <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                            <ahSuggestAccountingItemsSelector
                                ref="ahSuggestAccountingItemsSelector"
                                v-model="form.accno"
                                @loaded="onAhSuggestAccountingItemsSelectorLoaded"
                            ></ahSuggestAccountingItemsSelector>
                        </el-form-item>
                        <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="clearanceAccno" label="沖帳科目">
                            <ah-select-accounting-setting v-model="form.clearanceAccno" width="200px" :allowedGroups="['liabilitiesSettings', 'noeSettings']" />
                        </el-form-item>
                        <el-form-item prop="pdat" label="預計付款日期" v-if="isShowPdat">
                            <div class="flex-wrap">
                                <el-date-picker v-model="form.pdat" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                                <el-alert v-if="companyPdatTxt || companyCdatTxt" :closable="false" class="compact inline">
                                    <div v-if="companyCdatTxt !== null" style="margin-top: 5px">本期公司請款結算日： {{ companyCdatTxt }}</div>
                                    <div v-if="companyPdatTxt !== null">本期公司請款付款日： {{ companyPdatTxt }}</div>
                                </el-alert>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <span id="pay-to-anchor"></span>
                <div class="ah-panel" v-if="form.typ !== 6">
                    <div class="panel-header small">
                        <div class="panel-title">付款對象</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="paY_NAM" label="收款人名稱" v-if="form.typ === 5">
                            <el-input v-model="form.paY_NAM" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="paY_COUNRTY" label="國家" v-if="form.typ === 5">
                            <el-input v-model="form.paY_COUNRTY" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item label="付款對象" name="pay-to" v-if="form.typ !== 5">
                            <el-radio-group v-model="form.paY_TO" @change="handlePayToChange">
                                <el-radio-button :label="1" id="payment-add-page-pay-to-self">公司員工</el-radio-button>
                                <el-radio-button :label="2" id="payment-add-page-pay-to-vd">委外廠商</el-radio-button>
                                <el-radio-button :label="3" id="payment-add-page-pay-to-os">委外勞務</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <div v-if="form.typ !== 5">
                            <!-- 公司員工 -->
                            <el-form-item v-if="form.paY_TO === 1" prop="paY_STF_SNO" label="員工帳號">
                                <el-select
                                    v-model="form.paY_STF_SNO"
                                    filterable
                                    style="min-width: 310px; margin-right: 8px"
                                    no-data-text="無資料"
                                    no-match-text="無匹配資料"
                                    :placeholder="isLoadingStaffList ? '載入中...' : '請選擇'"
                                    :disabled="isLoadingStaffList"
                                    @change="handleStaffChange"
                                >
                                    <el-option-group label="Sokuji帳號員工">
                                        <el-option v-for="item in employeeList.filter((o) => o.typ === 1)" :key="item.sno" :label="item.name" :value="item.staff_SNO" class="payment-account-item">
                                            <div class="main clearfix">
                                                <div class="name">{{ item.name }}</div>
                                                <div class="dep" v-if="item.stafF_BNK_TPC">戶名：{{ item.stafF_BNK_TPC || "未填寫" }}</div>
                                            </div>
                                            <div class="sub">
                                                <div class="email">{{ item.email }}</div>
                                            </div>
                                        </el-option>
                                    </el-option-group>
                                    <el-option-group label="員工收款帳號">
                                        <el-option v-for="item in employeeList.filter((o) => o.typ === 2)" :key="item.sno" :label="item.name" :value="item.staff_SNO" class="payment-account-item">
                                            <div class="main clearfix">
                                                <div class="name">{{ item.name }}</div>
                                                <div class="dep" v-if="item.stafF_BNK_TPC">戶名：{{ item.stafF_BNK_TPC || "未填寫" }}</div>
                                            </div>
                                            <div class="sub">
                                                <div class="email">{{ protectedInfo(item.idNumber, "get", 4, true) }}</div>
                                            </div>
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                                <i v-if="isLoadingStaffList || isLoadingStaffData" class="el-icon-loading"></i>
                            </el-form-item>
                            <div v-if="form.paY_TO === 1 && form.useR_PAY_WAY === 2" class="secondary-block">
                                <el-form-item label-width="175px" prop="vdR_BNK_TPC" label="收款存摺戶名" :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_TPC : [{ required: false }]">
                                    <el-input v-model="form.vdR_BNK_TPC" style="max-width: 400px" :maxlength="200" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item label-width="175px" prop="vdR_BNK_BOO" label="收款銀行" :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_BOO : [{ required: false }]">
                                    <ah-el-select-bank v-model="form.vdR_BNK_BOO" :branch="form.vdR_BNK_DOO" @branchInput="form.vdR_BNK_DOO = $event"></ah-el-select-bank>
                                </el-form-item>
                                <el-form-item label-width="175px" prop="vdR_BNK_ACC" label="收款帳號" :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_ACC : [{ required: false }]">
                                    <ah-el-input-bank-acc v-model="form.vdR_BNK_ACC" :bankBoo="form.vdR_BNK_BOO" :maxlength="50"></ah-el-input-bank-acc>
                                </el-form-item>
                                <el-form-item label-width="175px" prop="vdR_BNK_NOTE" label="備註、其他資訊" :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_NOTE : [{ required: false }]">
                                    <el-input v-model="form.vdR_BNK_NOTE" :maxlength="30" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-alert show-icon :closable="false" type="warning" class="payInfoModifyWarning">
                                    <span v-if="staffTyp === 1">上方資料修改僅登錄於此請款單，如需永久修改，請至 "個人帳號" 編輯。</span>
                                    <span v-else>上方資料修改僅登錄於此請款單，如需永久修改，請通知權限管理者編輯。</span>
                                </el-alert>
                            </div>
                            <!-- 外包廠商 -->
                            <div v-if="form.paY_TO === 2" class="">
                                <el-form-item prop="vdR_SNO" label="選擇委外廠商">
                                    <div class="flex-wrap">
                                        <el-select
                                            v-model="form.vdR_SNO"
                                            filterable
                                            :placeholder="companyInfo.displayVendorOutsource ? '請選擇' : '請輸入委外廠商關鍵字（至少兩個字）'"
                                            :no-data-text="companyInfo.displayVendorOutsource ? '無資料' : '無匹配資料'"
                                            remote
                                            :remote-method="vendorRemoteMethod"
                                            @change="handleOursourcingCompanyChange"
                                            @keydown.native.capture.enter="preventIMESelect"
                                            style="width: 100%; max-width: 485px"
                                            no-match-text="無匹配資料"
                                        >
                                            <el-option v-for="item in vendorList" :key="item.sno" :label="item.fnam" :value="item.sno" />
                                        </el-select>
                                        <el-popconfirm
                                            v-if="isAuth('C03')"
                                            title="將前往新增，新增後會自動返回。"
                                            confirm-button-text="前往新增"
                                            cancel-button-text="取消"
                                            icon="el-icon-warning"
                                            @confirm="onAddOutsourcingBtnClick('company')"
                                        >
                                            <el-button icon="el-icon-plus" slot="reference" :disabled="!isAuth('C03')"></el-button>
                                        </el-popconfirm>
                                        <el-tooltip v-if="!isAuth('C03')" class="item" effect="dark" content="您沒有編輯委外權限" placement="top">
                                            <span>
                                                <el-button icon="el-icon-plus" :disabled="true"></el-button>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- 委外勞務 -->
                            <div v-else-if="form.paY_TO === 3">
                                <el-form-item prop="vdR_SNO" label="選擇委外勞務">
                                    <div class="flex-wrap">
                                        <el-select
                                            v-model="form.vdR_SNO"
                                            filterable
                                            :placeholder="companyInfo.displayPersonalOutsource ? '請選擇' : '請輸入委外勞務關鍵字（至少兩個字）'"
                                            :no-data-text="companyInfo.displayPersonalOutsource ? '無資料' : '無匹配資料'"
                                            remote
                                            :remote-method="outsourcingRemoteMethod"
                                            @change="handleOutsourcingPersonChange"
                                            @keydown.native.capture.enter="preventIMESelect"
                                            style="min-width: 290px"
                                            no-match-text="無匹配資料"
                                        >
                                            <el-option v-for="item in outsourcingList" :key="item.sno" :label="item.fnam" :value="item.sno" />
                                        </el-select>
                                        <el-popconfirm
                                            v-if="isAuth('C03')"
                                            title="將前往新增，新增後會自動返回。"
                                            confirm-button-text="前往新增"
                                            cancel-button-text="取消"
                                            icon="el-icon-warning"
                                            @confirm="onAddOutsourcingBtnClick('person')"
                                        >
                                            <el-button icon="el-icon-plus" slot="reference" :disabled="!isAuth('C03')"></el-button>
                                        </el-popconfirm>
                                        <el-tooltip v-if="!isAuth('C03')" class="item" effect="dark" content="您沒有編輯委外權限" placement="top">
                                            <span>
                                                <el-button icon="el-icon-plus" :disabled="true"></el-button>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- 帳戶資訊 -->
                            <el-form-item v-if="form.useR_PAY_WAY === 2 && form.vdR_SNO" prop="vdR_BNK_SNO" label="選擇匯款帳戶">
                                <el-select v-model="form.vdR_BNK_SNO" placeholder="請選擇" style="width: 100%; max-width: 550px; margin-right: 8px" @change="fillVendorTransferInfo">
                                    <el-option v-for="item in vdrBankList" :key="item.sno" :label="getVendorBankLabel(item)" :value="item.sno" class="vendor-transfer-item">
                                        <div class="account-name">{{ item.bnK_TPC }}</div>
                                        <div class="account-number">{{ item.bnK_BOO && `(${item.bnK_BOO})` }} {{ item.bnK_ACC }}</div>
                                        <div class="account-note" v-if="item.note">{{ item.note }}</div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="form.useR_PAY_WAY === 2 && form.vdR_SNO && form.paY_TO === 2" prop="vdR_CNR_SNO" label="選擇聯絡窗口">
                                <el-select v-model="form.vdR_CNR_SNO" placeholder="請選擇" style="width: 100%; max-width: 550px; margin-right: 8px" @change="fillVendorContactInfo">
                                    <el-option v-for="item in vdrContactList" :key="item.sno" :label="`${item.nam || '---'}`" :value="item.sno" class="vendor-transfer-item">
                                        <div class="account-name">{{ item.nam || "---" }}</div>
                                        <div class="account-number">
                                            電話：{{ item.tel || "---" }} <span v-if="item.ext">#{{ item.ext }}</span>
                                        </div>
                                        <div class="account-number">Email：{{ item.eml || "---" }}</div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <div v-show="form.vdR_SNO != null" class="secondary-block">
                                <el-form-item prop="abd" label-width="175px">
                                    <template slot="label">國籍</template>
                                    <el-radio v-model="form.abd" :label="0" disabled>本國</el-radio>
                                    <el-radio v-model="form.abd" :label="1" disabled>境外</el-radio>
                                </el-form-item>
                                <el-form-item v-if="form.abd == 1" prop="abD_TYP" label-width="175px">
                                    <template slot="label">境外類型</template>
                                    <el-radio v-model="form.abD_TYP" :label="2">民間</el-radio>
                                    <el-radio v-model="form.abD_TYP" :label="1">公營事業</el-radio>
                                    <el-radio v-model="form.abD_TYP" :label="0">政府</el-radio>
                                </el-form-item>
                                <el-form-item prop="accountType" label-width="175px">
                                    <template slot="label">帳戶類型</template>
                                    <el-radio v-model="form.accountType" :label="1">本國帳戶</el-radio>
                                    <el-radio v-model="form.accountType" :label="2">外國帳戶</el-radio>
                                </el-form-item>
                                <el-form-item
                                    v-if="form.useR_PAY_WAY === 2 && form.accountType === 2"
                                    prop="abroadBankName"
                                    label-width="175px"
                                    :rules="form.useR_PAY_WAY === 2 ? rules_alt.abroadBankName : [{ required: false }]"
                                >
                                    <template slot="label">境外銀行</template>
                                    <el-input v-model="form.abroadBankName" :maxlength="200" show-word-limit></el-input>
                                </el-form-item>
                                <el-form-item v-if="form.useR_PAY_WAY === 2 && form.accountType === 2" prop="swiftCode" label-width="175px" label="">
                                    <template slot="label">Swift Code</template>
                                    <el-input v-model="form.swiftCode"></el-input>
                                </el-form-item>
                                <el-form-item
                                    v-if="form.useR_PAY_WAY === 2"
                                    prop="vdR_BNK_TPC"
                                    label="存摺戶名"
                                    label-width="175px"
                                    :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_TPC : [{ required: false }]"
                                >
                                    <el-input v-model="form.vdR_BNK_TPC" style="max-width: 550px" :maxlength="200" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item
                                    v-if="form.useR_PAY_WAY === 2 && form.accountType === 1"
                                    prop="vdR_BNK_BOO"
                                    label="收款銀行"
                                    label-width="175px"
                                    :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_BOO : [{ required: false }]"
                                >
                                    <ah-el-select-bank v-model="form.vdR_BNK_BOO" :branch="form.vdR_BNK_DOO" @branchInput="form.vdR_BNK_DOO = $event"></ah-el-select-bank>
                                </el-form-item>
                                <el-form-item
                                    v-if="form.useR_PAY_WAY === 2"
                                    prop="vdR_BNK_ACC"
                                    label="收款帳號"
                                    label-width="175px"
                                    :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_ACC : [{ required: false }]"
                                >
                                    <ah-el-input-bank-acc v-model="form.vdR_BNK_ACC" :bankBoo="form.vdR_BNK_BOO" :maxlength="50"></ah-el-input-bank-acc>
                                </el-form-item>
                                <el-form-item prop="vdR_BNK_NOTE" label="備註、其他資訊" label-width="175px" :rules="form.useR_PAY_WAY === 2 ? rules_alt.vdR_BNK_NOTE : [{ required: false }]">
                                    <el-input v-model="form.vdR_BNK_NOTE" :maxlength="30" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <div style="padding: 35px 0 0 0"></div>
                                <el-form-item prop="vdR_NAM" label="聯絡人" label-width="175px">
                                    <el-input v-model="form.vdR_NAM" style="max-width: 300px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item prop="vdR_TEL" label="聯絡電話" label-width="175px">
                                    <el-input v-model="form.vdR_TEL" style="max-width: 500px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item prop="vdR_EML" label="聯絡信箱" label-width="175px">
                                    <el-input v-model="form.vdR_EML" style="max-width: 500px" :maxlength="50" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-alert show-icon :closable="false" type="warning" class="payInfoModifyWarning"> 上方資料修改僅登錄於此請款單，如需永久修改，請至 "專案 / 委外管理" 編輯。 </el-alert>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ah-panel" v-if="form.paY_TO === 3">
                    <div class="panel-header small">
                        <div class="panel-title">
                            勞務工作內容
                            <ahTip>勞務單上註記的工作內容</ahTip>
                        </div>
                    </div>
                    <div class="panel-body">
                        <el-form-item>
                            <el-input v-model="form.oS_MEM" type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="1000" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel" v-if="form.paY_TO === 3">
                    <div class="panel-header small">
                        <div class="panel-title">勞務代扣稅款</div>
                    </div>
                    <div class="panel-body">
                        <div class="tax-layout">
                            <div class="forms">
                                <el-form-item prop="serviceType" label="所得類別">
                                    <div style="display: flex; gap: 5px">
                                        <el-select v-model="form.serviceType" @change="onChangeServiceType" style="width: 290px">
                                            <el-option v-for="item in serviceTypeList" :key="`service-${item.label}`" :label="item.label" :value="item.value">
                                                <div class="main">{{ item.label }}</div>
                                            </el-option>
                                        </el-select>
                                        <el-button @click="taxAndGen2Dialog.visible = true" icon="el-icon-notebook-2">各類代扣簡表</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item v-if="form.serviceType === 1 || form.serviceType === 2" prop="serviceSubType" label="業別代號">
                                    <el-select
                                        v-model="form.serviceSubType"
                                        filterable
                                        placeholder="請選擇"
                                        style="min-width: 290px; margin-right: 8px"
                                        no-data-text="無資料"
                                        no-match-text="無匹配資料"
                                    >
                                        <el-option v-for="item in serviceSubTypeList" :key="item.key" :label="`${item.key}：${item.label}`" :value="item.key" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="form.serviceType === 0" prop="otherServiceType" label="其他類別說明">
                                    <el-input v-model="form.otherServiceType" :maxlength="50" :show-word-limit="true" style="width: 310px" />
                                </el-form-item>
                                <el-form-item label="請款單總額">
                                    <div class="amt-with-twd">
                                        <money-input v-model.number="form.amt" disabled :precision="form.cny === 'TWD' ? 0 : 4" style="width: 200px" :suffix="form.cny" />
                                        <div v-if="form.cny !== 'TWD'" class="twd">約當台幣：{{ amtTwdDisplay }} 元</div>
                                    </div>
                                </el-form-item>
                                <hr v-if="!isFullAuditFlow" class="tax-hr" />
                                <el-form-item prop="taX_AMT" :rules="!form.taX_CHK ? [{ required: false }] : rules.taX_AMT">
                                    <template slot="label">
                                        <el-checkbox v-model="form.taX_CHK" @change="onChangeTaxCheck"> 代扣勞務稅款</el-checkbox>
                                    </template>
                                    <div class="flex-wrap">
                                        <money-input v-model="tax_ratio" style="width: 120px" :precision="2" @keyup.native="onTaxRatioChange" suffix="%"></money-input>
                                        <div class="amt-with-twd">
                                            <money-input v-model.number="form.taX_AMT" :precision="form.cny == 'TWD' ? 0 : 4" :suffix="form.cny" @input="updateLaborTaxPercentage" />
                                            <div v-if="form.taX_CHK && form.cny !== 'TWD'" class="twd">約當台幣：<money :v="form.taX_AMT * form.paY_CNYRAT" round /> 元</div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <div v-if="isFullAuditFlow == false">
                                    <el-form-item prop="taX_PAY_DAT" label="繳款日期" :rules="!form.taX_CHK ? [{ required: false }] : rules.taX_PAY_DAT">
                                        <el-date-picker v-model="form.taX_PAY_DAT" value-format="timestamp" type="date" placeholder="請選擇" :disabled="!form.taX_CHK"> </el-date-picker>
                                        <div v-if="isTaxPayDateInvalid" class="date-warning">
                                            <i class="el-icon-warning-outline"></i>
                                            應於實際付款日之後
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="taX_BNK_SNO" label="繳款帳戶" :rules="!form.taX_CHK ? [{ required: false }] : rules.taX_BNK_SNO">
                                        <ah-el-select-bank-account
                                            v-model="form.taX_BNK_SNO"
                                            document-type="payment"
                                            :disabled="!form.taX_CHK"
                                            cny="TWD"
                                            hide-borrower
                                            allow-cash
                                        ></ah-el-select-bank-account>
                                    </el-form-item>
                                </div>
                                <hr v-if="!isFullAuditFlow" class="tax-hr" />
                                <el-form-item prop="geN2_AMT" :rules="!form.geN2_CHK ? [{ required: false }] : rules.geN2_AMT">
                                    <template slot="label">
                                        <el-checkbox v-model="form.geN2_CHK" @change="onChangeGen2Check"> 代扣二代健保</el-checkbox>
                                    </template>
                                    <div class="flex-wrap">
                                        <money-input v-model="gen2_ratio" style="width: 120px" :precision="2" @change="onGen2RatioChange" suffix="%"></money-input>
                                        <div class="amt-with-twd">
                                            <money-input v-model.number="form.geN2_AMT" :precision="form.cny == 'TWD' ? 0 : 4" :suffix="form.cny" @input="updateGen2Percentage" />
                                            <div v-if="form.geN2_CHK && form.cny !== 'TWD'" class="twd">約當台幣：<money :v="form.geN2_AMT * form.paY_CNYRAT" round /> 元</div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <div v-if="isFullAuditFlow == false">
                                    <el-form-item prop="geN2_PAY_DAT" label="繳款日期" :rules="!form.geN2_CHK ? [{ required: false }] : rules.geN2_PAY_DAT">
                                        <el-date-picker v-model="form.geN2_PAY_DAT" value-format="timestamp" type="date" placeholder="請選擇" :disabled="!form.geN2_CHK"> </el-date-picker>
                                        <div v-if="isGen2PayDateInvalid" class="date-warning">
                                            <i class="el-icon-warning-outline"></i>
                                            應於實際付款日之後
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="geN2_BNK_SNO" label="繳款帳戶" :rules="!form.geN2_CHK ? [{ required: false }] : rules.geN2_BNK_SNO">
                                        <ah-el-select-bank-account
                                            v-model="form.geN2_BNK_SNO"
                                            document-type="payment"
                                            :disabled="!form.geN2_CHK"
                                            cny="TWD"
                                            hide-borrower
                                            allow-cash
                                        ></ah-el-select-bank-account>
                                    </el-form-item>
                                </div>
                                <hr v-if="!isFullAuditFlow" class="tax-hr" />
                                <el-form-item label="實付金額">
                                    <div class="amt-with-twd">
                                        <money-input v-model.number="actualPayAmt" disabled :precision="form.cny === 'TWD' ? 0 : 4" style="width: 200px" :suffix="form.cny" />
                                        <span v-if="form.cny !== 'TWD'" class="twd">約當台幣：{{ actualPayAmtTwdDisplay }} 元</span>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="rules">
                                <div v-if="form.paY_TO === 3 && selectedServiceTypeInfo" class="service-type-note">
                                    <div class="name">{{ selectedServiceTypeInfo.label }}</div>
                                    <ol>
                                        <li v-if="form.abd === 2">勞務稅（非居住者）：{{ selectedServiceTypeInfo.notes.nonresidentTax }}</li>
                                        <li v-else>勞務稅（居住者）：{{ selectedServiceTypeInfo.notes.residentTax }}</li>
                                        <li>二代健保：{{ selectedServiceTypeInfo.notes.gen2 }}</li>
                                        <li>如有產生匯費，請至「銀行匯款明細、匯費」填寫匯費金額。</li>
                                        <li v-if="selectedOutsourcePerson && selectedOutsourcePerson.oS_GRP">
                                            {{ selectedOutsourcePerson && selectedOutsourcePerson.fnam }} 有投保職業工會或執照統編，免扣二代健保費。
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">檢附單據</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="toBeAddFile" label="待補單據標示">
                            <el-checkbox v-model="form.toBeAddFile">(將此請款單標示為"待補單據")</el-checkbox>
                        </el-form-item>
                        <el-form-item prop="" label="單據列表">
                            <ReceiptUploadInput v-model="form.files" :isShowTaxStatus="false" :cny="form.cny" :vdrSno="form.paY_TO === 2 && form.vdR_SNO" :vendorList="vendorList" />
                        </el-form-item>
                        <el-form-item prop="">
                            <template slot="label"> 單據總額(含稅)<ahTip>使用請款相同幣別</ahTip> </template>
                            <div class="flex-wrap">
                                <Money :v="receiptAmtTotal" :round="form.cny === 'TWD'" />
                                <span>{{ form.cny }}</span>
                                <el-alert v-if="form.amt != receiptAmtTotal" type="warning" class="compact inline" :closable="false">單據總額與付款金額不相符</el-alert>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-button v-if="form.sno" icon="el-icon-delete" type="danger" @click="handleDelete">作廢</el-button>
                    <el-button icon="el-icon-close" @click="handleClose">取消</el-button>
                    <el-button type="primary" class="primary-action" :loading="isSubmitting" id="payment-add-page-submit-btn" icon="el-icon-check" @click="handleSubmitBtnClick">送出</el-button>
                </div>
            </div>
        </el-form>
        <PaymentDetailDialog :visible="paymentDetailDialogVisible" :sno="paymentDetailDialogSno" @close="handlePaymentDetailDialogClose" />
        <TaxAndGen2Dialog :visible="taxAndGen2Dialog.visible" @close="taxAndGen2Dialog.visible = false" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import ahAuditFlowViewer from '@/components/ui/ahAuditFlowViewer.vue';
import ReceiptUploadInput from '@/components/ui/ReceiptUploadInput.vue';
import {
    paymentType, serviceTypeList, serviceType9AList, serviceType9BList,
} from '@/assets/commonData/options';
import confirm from '@/utils/confirm';
import { nullToString } from '@/utils/helpers';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import TaxAndGen2Dialog from '@/components/ui/TaxAndGen2Dialog.vue';
import { getTaxAmtInfo, getGen2AmtInfo } from '@/utils/OutsourcingPersonalTaxHelpers';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';
import {
    fetchAllEmployee, getStaffBySno, getAllOutsourcingCompany, getAllOutsourcingPerson, getOutsourcingCompanyBySno, getOutsourcingPersonBySno,
} from './PaymentApi';

export default {
    components: {
        ahElSelectBank,
        ahElSelectBankAccount,
        ahElInputBankAcc,
        ahSelectVariableStateItem,
        ahElSelectCny,
        ahAuditFlowViewer,
        PaymentStatusLabel,
        PaymentDetailDialog,
        ReceiptUploadInput,
        ahSuggestAccountingItemsSelector,
        TaxAndGen2Dialog,
        ahSelectAccountingSetting,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isAhSuggestAccountingItemsSelectorShow: false,
            isProject: false,
            isFetchingPayoutOptions: false,
            isSubmitting: false,
            isShowProjectPaymanetList: false,
            isShowAuditFlows: false,
            isLoadingStaffList: false,
            isLoadingStaffData: false,
            labelPosition: 'left',
            variableProjectTyp: 0, // 0: 無 | 1: 特支專案 | 2: 專案
            paymentDetailDialogVisible: false,
            paymentDetailDialogSno: null,
            attachFileDialogVisibility: false,
            sno: this.$route.params.sno,
            currSpProjectDetail: null, // 目前選中的特定費用項目詳細（已請款項目、審核流程）
            currOftenProjectDetail: null, // 目前選中經常性詳細（已請款項目、審核流程）
            selectedVendorBsn: '', // 選中的付款對象廠商統編
            selectedVendorName: '', // 選中的付款對象廠商名稱
            auditFlowSetting: {}, // 設定裡的審核流程設定
            payoutSno1: null,
            tax_ratio: 10,
            gen2_ratio: 2.11,
            availableCny: null,
            selectedOutsourcePerson: null,
            taxThreshold: 2000,
            currCash: null,
            serviceTypeList,
            staffTyp: null, // 選擇的付款員工類型，僅顯示判斷用（ahoo帳號員工 OR 員工收款帳號）
            payTwdAmt: null,
            suggestAccountItems: [],
            form: {
                dat: this.getCurrentDate().getTime(), // 請款單日期
                typ: 1, // 類型：1:一般請款2:專案請款3:特定費用請款 4:經常性支出請款 5:外幣請款 6:財務收支
                nam: '', // 請款項目名稱
                amt: null, // 請款金額
                geN2_CHK: false, // 是否扣二代健保
                geN2_AMT: 0, // 二代健保金額
                taX_CHK: false, // 是否扣勞務稅額
                taX_AMT: 0, // 勞務稅額金額
                useR_PAY_WAY: 2, // 預計付款方式 1=零用現金(扣ac_cash) 2=匯款銀行戶頭
                pdat: null, // 預計付款日
                filE_ATT: null, // 單據檔案
                paY_TO: 2, // 付款對象 1=申請人,2=委外廠商,3=委外勞務,4=外國
                paY_NAM: '', // 外幣收款人名
                paY_COUNRTY: '', // 外幣收款人國家
                vdR_SNO: null, // 付款對象：公司sno
                vdR_BNK_SNO: null, // 付款對象：帳戶
                vdR_CNR_SNO: null, // 付款對象：聯絡窗口
                poo: null, // 專案編號, 特定費用項目編號
                ofeN_ITEM_SNO: null, // 經常性支出項目編號
                cny: 'TWD', // 幣別
                paY_STF_SNO: null,
                vdR_BNK_BOO: '', // 銀行代碼
                vdR_BNK_DOO: '', // 分行代碼
                vdR_BNK_ACC: '', // 帳號
                vdR_BNK_NOTE: '', // 備註、其他資訊
                vdR_BNK_TPC: '', // 銀行戶名
                vdR_FILE_AGREE: null, // 上傳匯款同意書
                vdR_NAM: '', // 姓名
                vdR_TEL: '', // 電話
                vdR_EML: '', // 信箱

                accountType: null, // 帳戶類型
                vdR_ABD: 0, // 國籍
                abd: undefined,
                abD_TYP: null, // 境外身份
                abroadBankName: null, // 境外銀行
                swiftCode: null, // 境外swift code

                paY_CNYRAT: 1, // 當下匯率(外幣使用)

                paY_DAT: null, // (簡易流程) 付款日期
                paY_WAY: null, // (簡易流程) 付款方式
                paY_BNK_SNO: null, // (簡易流程) 付款銀行帳號
                geN2_BNK_SNO: null, // (簡易流程) 二代健保付款帳戶
                taX_BNK_SNO: null, // (簡易流程) 勞務稅額付款帳戶
                geN2_PAY_DAT: null, // (簡易流程) 代扣二代健保付款日期
                taX_PAY_DAT: null, // (簡易流程) 代扣稅付款日期
                iteM_SNO: null, // (簡易流程) 支出項目
                accno: null, // (簡易流程) 立帳科目
                clearanceAccno: null, // (簡易流程) 沖帳科目

                f_FOO: '',
                f_DAT: null,
                f_BSN: '',
                f_NAM: ' ',
                test: 0,
                oS_MEM: null, // 工作內容

                files: [],
                toBeAddFile: false,
                serviceType: null,
                serviceSubType: null,
                otherServiceType: null,
            },
            rules: {
                dat: [
                    {
                        required: true,
                        message: '請選擇請款日期',
                    },
                ],
                nam: [
                    {
                        required: true,
                        trigger: ['blur', 'change'],
                        message: '請填寫請款摘要',
                    },
                ],
                ofeN_ITEM_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇經常性支出項目',
                    },
                ],
                iteM_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇支出項目',
                    },
                ],
                pdat: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫預計付款日期',
                    },
                ],
                amt: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫請款金額',
                    },
                ],
                vdR_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇',
                    },
                ],
                paY_STF_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇',
                    },
                ],
                vdR_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇',
                    },
                ],
                poo: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇專案',
                    },
                ],
                taX_AMT: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請輸入勞務稅金',
                    },
                ],
                geN2_AMT: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請輸入二代健保稅金',
                    },
                ],
                taX_PAY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣稅付款日期',
                    },
                ],
                geN2_PAY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣二代健保付款日期',
                    },
                ],
                taX_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣稅付款帳戶',
                    },
                ],
                geN2_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣二代健保付款帳戶',
                    },
                ],
                payout_ITEM: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇支出項目',
                    },
                ],
                paY_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇轉出銀行',
                    },
                ],
                paY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇付款日期',
                    },
                ],
                paY_NAM: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫收款人姓名',
                    },
                ],
                serviceType: [
                    {
                        required: true,
                        message: '請填寫勞務所得類別',
                    },
                ],
                serviceSubType: [
                    {
                        required: true,
                        message: '請填寫執行業務類別',
                    },
                ],
                otherServiceType: [
                    {
                        required: true,
                        message: '請填寫其他類別說明',
                    },
                ],
            },
            rules_alt: {
                vdR_BNK_BOO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇銀行',
                    },
                ],
                vdR_BNK_ACC: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫帳號',
                    },
                ],
                vdR_BNK_TPC: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫戶名',
                    },
                ],
                abroadBankName: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請填寫銀行名稱',
                    },
                ],
            },
            vendor: {
                caT_SNO: null,
                bnK_BOO: null,
                bnK_DOO: null,
            },
            outsourcing: {
                caT_SNO: null,
                bnK_BOO: null,
                bnK_DOO: null,
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
            vendorList: [],
            outsourcingList: [],
            employeeList: [],
            vdrBankList: [],
            vdrContactList: [],
            projectList: [],
            specialProjectList: [],
            oftenProjectList: [],
            branchList: [],
            projectPayouts: [],
            selectedProject: null,
            forceAmtUpdate: 0,
            activeFileIndex: null,
            temp: {
                paY_TO: null,
            },
            taxAndGen2Dialog: {
                visible: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
            userSno: 'account/userSno',
            cnyOptions: 'cny/cnyOptions',
        }),
        serviceSubTypeList() {
            switch (this.form.serviceType) {
            case 1:
                return serviceType9AList;
            case 2:
                return serviceType9BList;
            default:
                return [];
            }
        },
        gen2Threshold() {
            return this.form.serviceType === 3 ? 28590 : 20000;
        },
        gen2ThresholdText() {
            return this.gen2Threshold.toLocaleString('en');
        },
        isProjectBudgetVisible() {
            return this.isAuth('C04') || this.selectedProject.stF_SNO === this.userSno;
        },
        isDisableBankTransfer() {
            return this.payment && this.payment.useR_PAY_WAY === 1;
        },
        // 審核流程判斷
        currentFlow() {
            if (this.form.typ === 1 || this.form.typ === 5) {
                return this.auditFlowSetting.payoutAuditFlowSetting?.settings;
            }
            if (this.form.typ === 2) {
                return this.auditFlowSetting.projectAuditFlowSetting?.settings;
            }
            return [];
        },
        isFlowValidate() {
            if (!this.isFullAuditFlow) return true;
            let isValidated = false;
            const amt = this.form.amt * this.form.paY_CNYRAT;

            if (this.currentFlow?.length) {
                this.currentFlow?.forEach((item) => {
                    if (amt >= item.startAmount && amt <= item.endAmount) {
                        isValidated = true;
                    }
                });
            } else isValidated = true;

            return isValidated;
        },

        // 委外勞務代扣稅款 顯示狀態
        isTaxNeeded() {
            return this.form.typ !== 5 && this.form.paY_TO === 3;
        },
        isLaborTaxShow() {
            if (!this.form.vdR_SNO) return false;
            const RAT = this.form.cny === 'TWD' ? 1 : this.form.paY_CNYRAT;

            if (this.form.serviceType !== 3) {
                if (this.tax_ratio) {
                    return this.form.paY_TO === 3 && Math.floor(this.form.amt * RAT * this.tax_ratio * 0.01) > this.taxThreshold;
                }

                return this.form.paY_TO === 3 && Math.floor(this.form.amt * RAT * 0.1) > this.taxThreshold;
            }

            if (this.tax_ratio) {
                return this.form.paY_TO === 3 && Math.floor(this.form.amt * RAT) >= 86001;
            }

            return false;
        },
        isGen2Show() {
            if (!this.form.vdR_SNO) return false;
            const RAT = this.form.cny === 'TWD' ? 1 : this.form.paY_CNYRAT;
            return this.form.paY_TO === 3 && this.form.amt * RAT >= this.gen2Threshold;
        },
        isShowPayBnk() {
            // 簡易流程 && 銀行付款
            if (!this.isFullAuditFlow && this.form.useR_PAY_WAY !== 1) {
                return true;
            }

            return false;
        },
        isShowPayDat() {
            // 財務收支 (typ === 6)
            if (this.form.typ === 6) return true;

            // 簡易流程
            if (!this.isFullAuditFlow) return true;

            return false;
        },
        isShowStatementItem() {
            // 財務收支 (typ === 6)
            if (this.form.typ === 6) return true;

            // 簡易流程
            if (!this.isFullAuditFlow) return true;

            return false;
        },
        isShowPdat() {
            // 財務收支不顯示
            if (this.form.typ === 6) return false;

            // 簡易流程不顯示
            if (!this.isFullAuditFlow) return false;

            return true;
        },
        // 實付金額
        actualPayAmt() {
            const tax = this.isLaborTaxShow || this.form.taX_CHK ? this.form.taX_AMT : 0;
            const gen2 = this.isGen2Show || this.form.geN2_CHK ? this.form.geN2_AMT : 0;
            return this.form.amt - tax - gen2;
        },
        amtTwd() {
            return Math.round(this.form.amt * this.form.paY_CNYRAT);
        },
        amtTwdDisplay() {
            return this.amtTwd.toLocaleString('en');
        },
        actualPayAmtTwdDisplay() {
            const TAX_TWD_AMT = Math.round(this.form.taX_AMT * this.form.paY_CNYRAT);
            const GEN2_TWD_AMT = Math.round(this.form.geN2_AMT * this.form.paY_CNYRAT);
            return (this.amtTwd - TAX_TWD_AMT - GEN2_TWD_AMT).toLocaleString('en');
        },

        // 公司請款結算日 - Moment
        companyCdatMoment() {
            if (!this.companyInfo.payouT_CDAT) return null;

            const d = moment().date(this.companyInfo.payouT_CDAT);
            if (moment().isAfter(d)) d.add(1, 'month');
            if (this.companyInfo.payouT_CDAT === 29) d.endOf('month');
            return d.startOf('day');
        },
        // 公司預設請款付款日 - Moment
        companyPdatMoment() {
            if (!this.companyInfo.payouT_PDAT) return null;

            const d = moment().date(this.companyInfo.payouT_PDAT);
            const payoutCdat = moment().date(this.companyInfo.payouT_CDAT);
            if (this.companyInfo.payouT_PDAT === 29) d.endOf('month');

            if (this.companyInfo.payouT_CDAT) {
                if (moment().isAfter(payoutCdat)) d.month(payoutCdat.month() + 1);
                if (this.companyInfo.payouT_CDAT > this.companyInfo.payouT_PDAT) d.add(1, 'month');
            }
            return d.startOf('day');
        },
        // 公司請款結算日 - 文字
        companyCdatTxt() {
            return this.companyCdatMoment?.format('MM 月 DD 日');
        },
        // 公司預設請款付款日 - 文字
        companyPdatTxt() {
            return this.companyPdatMoment?.format('MM 月 DD 日');
        },

        selectedProjectPayoutPercentage() {
            if (this.selectedProject.payoutMax > 0) {
                return Math.round((this.selectedProject.payoutTotal / this.selectedProject.payoutMax) * 100);
            }
            return 0;
        },
        activeAttachFile() {
            if (this.activeFileIndex !== null) {
                return this.form.files[this.activeFileIndex];
            }
            return null;
        },
        receiptAmtTotal() {
            const SUM = _.chain(this.form.files)
                .filter((o) => !o.delete)
                .sumBy('amt')
                .value();
            return Math.round(SUM * 100) / 100;
        },
        paymentTypeOptions() {
            // 有 A02, A03 權限的人才能使用全部類型
            if (this.isAuthOne(['A02', 'A03'])) {
                return paymentType.filter((x) => x.key !== null);
            }
            // 沒有 A02, A03 的人要剔除 typ:6 財務收支
            return paymentType.filter((x) => x.key !== null && x.key !== 6);
        },

        getProjectTitle() {
            switch (this.form.typ) {
            case 2:
                return '所屬專案';
            case 3:
                return '特定費用項目';
            case 6:
                return this.variableProjectTyp === 1 ? '特定費用項目' : '所屬專案';
            case 4:
                return '特許支出';
            default:
                return '';
            }
        },

        getReturnInfo() {
            if (this.form.audits) {
                return this.form.audits.find((x) => x.fin === 3);
            }
            return null;
        },

        // 經常性支出金額範圍
        currExpendAmtSpan() {
            const vproject = this.oftenProjectList.find((obj) => obj.sno === this.form.ofeN_ITEM_SNO);

            if (vproject) {
                return {
                    min: vproject.amT_S,
                    max: vproject.amT_E,
                };
            }
            return null;
        },

        // 簡易審核流程
        isFullAuditFlow() {
            // 特定費用：讀取特定費用項目的審核流程
            if (this.form.typ === 3) {
                const proj = this.specialProjectList.find((x) => x.poo === this.form.poo);
                if (proj) {
                    return proj.sP_FLAG;
                }
                return true;
            }
            // 經常性支出：讀取經常性支出的審核流程
            if (this.form.typ === 4) {
                const item = this.oftenProjectList.find((x) => x.sno === this.form.ofeN_ITEM_SNO);
                if (item) {
                    return item.ofteN_FLAG;
                }
                return true;
            }
            // 專案
            if (this.form.typ === 2) {
                if (this.auditFlowSetting.projectAuditFlowSetting) {
                    return this.auditFlowSetting.projectAuditFlowSetting.isEnable;
                }
                return false;
            }
            // 一般、外幣 請款，使用設定裡的流程開關
            if (this.form.typ === 1 || this.form.typ === 5) {
                if (this.auditFlowSetting.payoutAuditFlowSetting) {
                    return this.auditFlowSetting.payoutAuditFlowSetting.isEnable;
                }
                return false;
            }
            // 錯誤

            return null;
        },

        // 審核流程預覽
        auditFlowItems() {
            // 一般請款，專案請款，外幣請款
            if (this.form.typ === 1 || this.form.typ === 2 || this.form.typ === 5) {
                // 使用設定裡的審核流程（去除ADD)
                if (this.auditFlowSetting && this.auditFlowSetting.payoutAuditFlowSetting) {
                    return this.auditFlowSetting.payoutAuditFlowSetting.settings.filter((x) => x.menU_UNT !== 'ADD');
                }
                return null;
            }

            // 特定費用
            if (this.form.typ === 3) {
                if (this.currSpProjectDetail) {
                    return this.currSpProjectDetail.auditFlowItems;
                }
                return null;
            }

            // 經常性費用
            if (this.form.typ === 4) {
                if (this.currOftenProjectDetail) {
                    return this.currOftenProjectDetail.auditFlowItems;
                }
                return null;
            }
            return null;
        },

        currVariableProject() {
            if (this.form.typ === 4) {
                return this.oftenProjectList.find((x) => x.sno === this.form.ofeN_ITEM_SNO);
            }
            return null;
        },
        isTaxPayDateInvalid() {
            return this.form.taX_CHK && this.form.taX_PAY_DAT !== null && this.form.taX_PAY_DAT < this.form.paY_DAT;
        },

        isGen2PayDateInvalid() {
            return this.form.geN2_CHK && this.form.geN2_PAY_DAT !== null && this.form.geN2_PAY_DAT < this.form.paY_DAT;
        },

        selectedServiceTypeInfo() {
            return serviceTypeList.find((x) => x.value === this.form.serviceType);
        },
    },
    async mounted() {
        await this.$store.dispatch('accounting/updateAccountingSettings');
        this.fetchCash();
        await this.fetchAuditFlow();

        // ===== 編輯 =====
        const { sno } = this.$route.params;
        if (sno) {
            // 載入欄位資料
            const resp = await this.$api({
                url: `/PaymentManagenmentPage/GetPaymentInfo?Sno=${sno}`,
                method: 'GET',
            });

            this.form = { ...resp.data.item, accountType: null };

            // 暫存
            this.temp.paY_TO = this.form.paY_TO;
        } else if (!this.isFullAuditFlow) this.form.clearanceAccno = '2131';

        // ===== 複製請款單 =====
        if (!sno) {
            const sourceSno = this.$route.query.copyfrom;
            if (sourceSno) {
                // 複製欄位資料
                await this.copyFromSno(sourceSno, this.$route.query.receipt);
            }
        }

        // ===== 載入 cache 資料（用於外部新增後跳轉回來）=====
        if (this.$route.query.cache === 1) {
            this.loadFromCache();
        }

        // 更新前端用於計算外幣約當台幣的變數
        if (this.form.cny !== 'TWD') {
            this.payTwdAmt = Math.round(this.form.amt * this.form.paY_CNYRAT);
        }

        // ===== 重新計算回代扣稅率 ======
        if (this.form.taX_AMT) {
            this.tax_ratio = Math.round((this.form.taX_AMT / this.form.amt) * 10000) / 100;
        }
        if (this.form.geN2_AMT) {
            this.gen2_ratio = Math.round((this.form.geN2_AMT / this.form.amt) * 10000) / 100;
        }

        // 代扣方式付款：現金，的特別處理（前端將現金整合到下拉列表，後端則是記錄在 xxxx_PAY_WAY = 1)）
        if (this.form.taX_PAY_WAY === 1) this.form.taX_BNK_SNO = -1;
        if (this.form.geN2_PAY_WAY === 1) this.form.geN2_BNK_SNO = -1;

        // ===== 載入專案列表 ======
        // 載入專案下拉列表
        if (this.form.typ === 2 || this.form.typ === 6) {
            // 專案
            this.fetchProjectList(
                () => {
                    this.handleProjectChange();
                },
                !this.companyInfo.displayProject,
                this.form.projectName,
            );
        } else if (this.form.typ === 3 || this.form.typ === 6) {
            // 特支專案
            this.fetchSpecialProjectList(() => {
                this.handleProjectChange();
            });
        } else if (this.form.typ === 4) {
            // 經常性費用
            this.fetchOftenOptions();
        }

        // ===== 載入付款對象 ======
        // 付款對象：「公司員工」 （載入委外廠商下拉列表）
        if (this.form.paY_TO === 1) {
            // 載入公司員工下拉列表
            this.isLoadingStaffList = true;
            this.employeeList = await fetchAllEmployee();
            this.isLoadingStaffList = false;

            // 載入選取的項目
            if (this.form.paY_STF_SNO) {
                this.isLoadingStaffData = true;
                this.applyStaffPayInfos(this.form.paY_STF_SNO);
                this.isLoadingStaffData = false;
            }
        }
        // 付款對象：委外廠商
        if (this.form.paY_TO === 2) {
            // 載入委外廠商下拉列表
            if (this.companyInfo.displayVendorOutsource) {
                this.vendorList = await getAllOutsourcingCompany();
            }
            // 載入選取的項目
            if (this.form.vdR_SNO) {
                this.applyOutsourcingCompany(this.form.vdR_SNO, this.form.vdR_BNK_SNO, this.form.vdR_CNR_SNO, true);
            }
        }
        // 付款對象：委外勞務
        if (this.form.paY_TO === 3) {
            // 載入委外勞務下拉列表
            if (this.companyInfo.displayPersonalOutsource) {
                this.outsourcingList = await getAllOutsourcingPerson();
            }
            // 載入選取的項目
            if (this.form.vdR_SNO) {
                this.applyOutsourcingPerson(this.form.vdR_SNO, this.form.vdR_BNK_SNO, true);
            }
        }

        // ===== 檢查跳轉返回指定選項 ====
        // 新增「委外廠商」跳轉回來
        if (this.$route.query.outsourcingtype === 'company') {
            this.form.paY_TO = 2;
            this.handlePayToChange();

            if (this.$route.query.outsourcingsno != null) {
                this.form.vdR_SNO = parseInt(this.$route.query.outsourcingsno, 10);
                this.handleOursourcingCompanyChange(this.form.vdR_SNO);
                this.scrollTo('pay-to-anchor');
            }
        }
        // 新增「委外個人」跳轉回來
        if (this.$route.query.outsourcingtype === 'person') {
            this.form.paY_TO = 3;
            this.handlePayToChange();

            if (this.$route.outsourcingsno !== null) {
                this.form.vdR_SNO = parseInt(this.$route.query.outsourcingsno, 10);
                this.handleOutsourcingPersonChange(this.form.vdR_SNO);
                this.scrollTo('pay-to-anchor');
            }
        }

        // 預填公司設定的付款日
        if (!this.form.pdat) {
            setTimeout(() => {
                this.setDefaultPdat();
            }, 500);
        }
    },
    created() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    methods: {
        /**
         * 偵聽視窗大小變更
         */
        handleWindowResize() {
            this.labelPosition = window.innerWidth < 768 ? 'top' : 'right';
        },
        onTwdAmtChange() {
            this.form.paY_CNYRAT = Math.round((this.payTwdAmt / this.form.amt) * 100) / 100;
        },
        onCnyRatChange() {
            this.payTwdAmt = Math.round(this.form.amt * this.form.paY_CNYRAT);
        },
        setDefaultPdat() {
            if (this.isShowPdat) this.form.pdat = this.companyPdatMoment ? Number(this.companyPdatMoment.format('x')) : null;

            // 簡易流程，要帶入實際付款日期
            if (!this.isFullAuditFlow) {
                this.form.paY_DAT = this.companyPdatMoment ? Number(this.companyPdatMoment.format('x')) : null;
            }
        },
        fetchCash() {
            this.$api({
                url: '/Tool/GetCashBalance',
                method: 'GET',
            }).then((resp) => {
                this.currCash = resp.data.balance;
            });
        },
        saveToCache() {
            console.log('payment cached');
            localStorage.setItem('payment-cashe', JSON.stringify(this.form));
        },

        loadFromCache() {
            const rowdata = localStorage.getItem('payment-cashe');
            if (rowdata) {
                this.applyFormData(JSON.parse(rowdata));
            }
            if (!rowdata) {
                console.log('no cached data found.');
            }
        },

        applyFormData(targetForm) {
            for (const [key, value] of Object.entries(targetForm)) {
                this.form[key] = value;
            }
        },

        onAddOutsourcingBtnClick(osType) {
            this.saveToCache();

            if (osType === 'company') {
                this.$router.push({
                    name: 'outsourcing-add-company',
                    query: {
                        from: 'payment-add',
                    },
                });
            } else if (osType === 'person') {
                this.$router.push({
                    name: 'outsourcing-add-person',
                    query: {
                        from: 'payment-add',
                    },
                });
            }
        },

        // 變更請款類型
        // 1:一般請款 2:專案請款 3:特定費用請款 4:經常性支出請款 5:外幣請款 6:財務收支
        onTypChange(type) {
            if (!this.isFullAuditFlow) {
                if (type === 2) this.form.clearanceAccno = '2121';
                else this.form.clearanceAccno = '2131';
            }

            if (type === 2 || type === 6) this.fetchProjectList(null, !this.companyInfo.displayProject);

            if (type === 3 || type === 6) this.fetchSpecialProjectList();

            if (type === 4) this.fetchOftenOptions();

            if (type === 5) {
                this.form.paY_TO = 4;
                this.form.cny = 'TWD';
            }

            // 6:財務收支
            if (type === 6) {
                // 無需填付款對象（通常是銀行自動扣款）
                this.form.paY_TO = null;

                // 一定是用銀行轉帳
                this.form.paY_WAY = 2;
                this.form.useR_PAY_WAY = 2;
            } else if (type !== 5) {
                this.form.paY_TO = this.temp.paY_TO || 2;
            }

            // 重置

            this.projectPayouts = [];
            // this.form.nam = '';
            this.form.poo = null;
            this.form.iteM_SNO = null;
            this.form.ofeN_ITEM_SNO = null;
            this.form.currSpProjectDetail = null;
            this.form.currOftenProjectDetail = null;
            this.selectedProject = null;
            this.availableCny = null;
            this.selectedVendorBsn = '';
            this.selectedVendorName = '';
            this.selectedOutsourcePerson = null;
        },

        handlePdatChange() {
            const divideDate = new Date('2021-01-01T00:00');
            if (this.form.pdat <= divideDate.getTime()) {
                this.gen2_ratio = 1.91;
            } else {
                this.gen2_ratio = 2.11;
            }
            this.onGen2RatioChange();
        },
        handleAmtChange() {
            this.tax_ratio = this.form.serviceType === 3 ? 5 : 10;
            this.gen2_ratio = 2.11;
            if (this.form.cny !== 'TWD' && this.isFullAuditFlow === false) this.onCnyRatChange();
            this.initTaxInfo();
        },

        onTaxRatioChange() {
            this.form.taX_CHK = true;
            this.form.taX_AMT = this.form.cny === 'TWD' ? Math.floor(this.form.amt * (this.tax_ratio / 100)) : Math.round(this.form.amt * (this.tax_ratio / 100) * 10000) / 10000;
            if (!this.form.taX_AMT) this.form.taX_CHK = false;
        },

        onGen2RatioChange() {
            if (this.form.paY_TO !== 3) return;
            this.form.geN2_CHK = true;
            this.form.geN2_AMT = this.form.cny === 'TWD' ? Math.round((this.form.amt * this.gen2_ratio) / 100) : Math.round(((this.form.amt * this.gen2_ratio) / 100) * 10000) / 10000;
            if (!this.form.geN2_AMT) this.form.geN2_CHK = false;
        },

        handleCnyChange() {
            this.form.paY_BNK_SNO = null;
            this.form.paY_CNYRAT = this.getCnyRat(this.form.cny);
            // 觸發勞務稅、二代健保重新計算
            this.initTaxInfo();

            this.onCnyRatChange();
        },

        updateLaborTaxPercentage() {
            this.form.taX_CHK = true;
            this.tax_ratio = Math.round((this.form.taX_AMT / this.form.amt) * 10000) / 100;
            if (!this.tax_ratio) this.form.taX_CHK = false;
        },
        updateGen2Percentage() {
            this.form.geN2_CHK = true;
            this.gen2_ratio = Math.round((this.form.geN2_AMT / this.form.amt) * 10000) / 100;
            if (!this.gen2_ratio) this.form.geN2_CHK = false;
        },
        onChangeTaxCheck(val) {
            if (val) {
                if (this.form.serviceType === 3) {
                    this.tax_ratio = 5;
                } else {
                    this.tax_ratio = 10;
                }
                this.onTaxRatioChange();
            } else {
                this.form.taX_AMT = 0;
                this.tax_ratio = 0;
            }
        },
        onChangeGen2Check(val) {
            if (val) {
                this.gen2_ratio = 2.11;
                this.onGen2RatioChange();
            } else {
                this.form.geN2_AMT = 0;
                this.gen2_ratio = 0;
            }
        },

        initTaxInfo() {
            // 使用台幣計算
            const cnyRat = this.getCnyRat(this.form.cny);
            const amtTwd = Math.round(this.form.amt * cnyRat);

            // 計算勞務稅
            const isResident = this.form.abd === 0 || this.form.abd === 1; // 居住者：國籍 = 0(本國籍) || 1(外國籍(在台已滿183天))
            const taxInfo = getTaxAmtInfo(this.form.serviceType, amtTwd, isResident);
            if (this.form.cny === 'TWD') {
                this.form.taX_AMT = taxInfo.amt;
            } else {
                this.form.taX_AMT = _.round(taxInfo.amt / cnyRat, 2);
            }
            this.form.taX_CHK = this.form.taX_AMT > 0;
            this.tax_ratio = taxInfo.ratio;

            // 計算二代健保
            let hasUnionInsurance = false;
            // 委外勞務有加入工會，或有營業統編
            if (this.selectedOutsourcePerson?.oS_GRP === true || this.selectedOutsourcePerson?.bsN_TYP === 2) {
                hasUnionInsurance = true;
            }
            const gen2Info = getGen2AmtInfo(this.form.serviceType, amtTwd, hasUnionInsurance);
            if (this.form.cny === 'TWD') {
                this.form.geN2_AMT = gen2Info.amt;
            } else {
                this.form.geN2_AMT = _.round(gen2Info.amt / cnyRat, 2);
            }
            this.form.geN2_CHK = this.form.geN2_AMT > 0;
            this.gen2_ratio = gen2Info.ratio;
            /*
            // 勞務類型其他，無勞務稅、二代健保
            if (this.form.serviceType === 0) {
                this.tax_ratio = 0;
                this.form.taX_CHK = false;
                this.form.taX_AMT = 0;
                this.gen2_ratio = 0;
                this.form.geN2_CHK = false;
                this.form.geN2_AMT = 0;
                return;
            }

            // 委外勞務超過 20000 元
            if (this.form.paY_TO === 3 && this.isLaborTaxShow) {
                // 勞務税
                this.form.taX_CHK = true;
                this.form.taX_AMT = this.form.cny === 'TWD' ? Math.floor(this.form.amt * (this.tax_ratio / 100)) : Math.round(this.form.amt * (this.tax_ratio / 100) * 10000) / 10000;
            } else {
                // 勞保歸零
                this.form.taX_CHK = false;
                this.form.taX_AMT = 0;
            }

            // 委外勞務超過 20000 元
            if (this.form.paY_TO === 3 && this.isGen2Show) {
                if (this.selectedOutsourcePerson && this.selectedOutsourcePerson.oS_GRP === true) {
                    // 二代健保（有工會）
                    this.form.geN2_CHK = false;
                    this.form.geN2_AMT = 0;
                } else if (this.selectedOutsourcePerson && this.selectedOutsourcePerson.bsN_TYP === 2) {
                    // 二代健保（有職業統編）
                    this.form.geN2_CHK = false;
                    this.form.geN2_AMT = 0;
                } else {
                    // 二代健保（無工會）
                    this.form.geN2_CHK = true;
                    this.form.geN2_AMT = this.form.cny === 'TWD' ? Math.round((this.form.amt * this.gen2_ratio) / 100) : Math.round(((this.form.amt * this.gen2_ratio) / 100) * 10000) / 10000;
                }
            } else {
                // 二代健保歸零
                this.form.geN2_CHK = false;
                this.form.geN2_AMT = 0;
            }
            */
        },

        // 取消，跳回列表
        handleClose() {
            this.$router.push({ name: 'payment' });
            this.$refs.form.resetFields();
        },

        scrollTo(id) {
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
            });
        },

        handleShowProjectPaymentListBtnClick(event) {
            this.isShowProjectPaymanetList = !this.isShowProjectPaymanetList;

            let { target } = event;
            if (target.nodeName === 'SPAN') {
                target = event.target.parentNode;
            }
            target.blur();
        },

        handlePaymentPayooClick(sno) {
            this.paymentDetailDialogSno = sno;
            this.paymentDetailDialogVisible = true;
        },

        handlePaymentDetailDialogClose() {
            this.paymentDetailDialogVisible = false;
            this.paymentDetailDialogSno = null;
        },

        // 取得目前日期
        getCurrentDate() {
            const d = new Date();
            d.setHours(0, 0, 0, 0);
            return d;
        },

        // 取得專案列表
        fetchProjectList(callback, init, query) {
            this.$api({
                url: 'PaymentManagenmentPage/GetProjectOptions?Type=1',
                method: 'GET',
                params: { keyword: query },
            }).then((resp) => {
                if (init) this.projectList = resp.data.options.filter((proj) => proj.poo === this.form.poo);
                else this.projectList = resp.data.options;

                if (typeof callback === 'function') callback();
            });
        },
        // 取得特定費用項目列表
        fetchSpecialProjectList(callback) {
            this.$api({
                url: '/PaymentManagenmentPage/GetProjectOptions?Type=2',
                method: 'GET',
            }).then((resp) => {
                this.specialProjectList = resp.data.options;

                if (typeof callback === 'function') callback();
            });
        },
        // 取得經常性支出列表
        fetchOftenOptions() {
            this.$api({
                url: '/PaymentManagenmentPage/GetOftenOptions',
                method: 'GET',
            }).then((resp) => {
                this.oftenProjectList = resp.data.options;
            });
        },
        projectRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            switch (this.form.typ) {
            case 2:
                this.fetchProjectList(null, false, query);
                break;
            case 3:
                this.fetchSpecialProjectList(query);
                break;
            case 6:
                if (this.variableProjectTyp === 1) this.fetchSpecialProjectList(query);
                else this.fetchProjectList(null, false, query);
                break;
            default:
                console.log('unkenown project typ');
            }
        },

        // 取得銀行分行
        fetchBranchList(value, refresh = true) {
            if (refresh) this.form.bnK_DOO = '';
            this.$api({
                url: `/Tool/GetBranchOptions?BOO=${value}`,
                method: 'get',
            }).then((resp) => {
                this.branchList = resp.data.options;
            });
        },

        // 取得委外廠商
        fetchVendorList(callback, init, query) {
            // 現有廠商清單
            return this.$api({
                url: '/PaymentManagenmentPage/GetVendorOutsourcingList',
                method: 'GET',
                params: { PageSize: 999, PageNum: 1, nam: query },
            }).then((resp) => {
                if (init) this.vendorList = resp.data.items.filter((vdr) => vdr.sno === this.form.vdR_SNO);
                else this.vendorList = resp.data.items;

                if (this.form.paY_TO === 2) {
                    const vdr = this.vendorList.find((o) => o.sno === this.form.vdR_SNO);
                    this.vdrBankList = vdr?.vendorBanks || [];
                    this.vdrContactList = vdr?.vendorContacts || [];
                }
                if (typeof callback === 'function') callback();
            });
        },
        vendorRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchVendorList(null, false, query);
        },

        // 取得委外勞務
        fetchOutsourcingList(callback, init, query) {
            return this.$api({
                url: '/PaymentManagenmentPage/GetPersonalOutsourcingList',
                method: 'GET',
                params: { PageSize: 999, PageNum: 1, nam: query },
            }).then((resp) => {
                if (init) this.outsourcingList = resp.data.items.filter((o) => o.sno === this.form.vdR_SNO);
                else this.outsourcingList = resp.data.items;

                if (this.form.paY_TO === 3) {
                    const vdr = this.outsourcingList.find((o) => o.sno === this.form.vdR_SNO);
                    this.vdrBankList = vdr?.vendorBanks || [];
                }
                if (typeof callback === 'function') callback();
            });
        },

        outsourcingRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchOutsourcingList(null, false, query);
        },

        // 載入設定裡的請款流程
        async fetchAuditFlow() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GetAuditFlowTemplates',
                    method: 'GET',
                });

                this.auditFlowSetting = resp.data;
            } catch (e) {
                console.log(e);
            }
        },

        // 送出
        async handleSubmitBtnClick() {
            this.submit();
        },

        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },

        async submit() {
            // 表單驗證
            this.$refs.form.validate(async (valid) => {
                if (!valid) {
                    // 表單驗證未過
                    this.$message.warning({
                        showClose: true,
                        message: '請填寫必填欄位',
                        type: 'warning',
                    });
                    this.scrollViewToError();
                } else {
                    // 表單驗證有過，驗證其他項目
                    try {
                        // 選擇預計付款方式為「零用現金」時，清除銀行付款的資訊（複製請款單可能會帶到）
                        if (this.form.useR_PAY_WAY === 1) {
                            this.form.paY_WAY = 1;
                            this.form.vdR_BNK_TPC = '';
                            this.form.vdR_BNK_BOO = '';
                            this.form.vdR_BNK_DOO = '';
                            this.form.vdR_BNK_ACC = '';
                            this.form.vdR_BNK_NOTE = '';
                        }

                        // 檢查是否為審核流程空缺
                        await this.validateAuditFlow();

                        // 檢查請款單年份
                        await this.validateYearDiff();

                        // 檢查代扣所得稅日期不早於付款日期
                        if (this.isTaxNeeded && !this.isFullAuditFlow) {
                            if (this.isTaxPayDateInvalid || this.isGen2PayDateInvalid) {
                                this.$message({
                                    showClose: true,
                                    message: '代扣所得稅、代扣二代健保繳款日應於實際付款日之後',
                                    type: 'error',
                                });
                                return;
                            }
                        }

                        // 檢查單據與金額
                        await this.validateFileAmt();

                        // 送出請款資料
                        this.submitPayment();
                    } catch (e) {
                        console.log(e);
                        if (e.message === 'invaild-audit-flow') {
                            await this.$alert('沒有對應的審核流程，請確認付款金額與審核流程預覽。');
                            const isError = document.getElementById('no-flow-error');
                            isError.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            });
                        }
                    }
                }
            });
        },
        // 檢查是否為審核流程空缺
        async validateAuditFlow() {
            if (!this.isFlowValidate) {
                throw new Error('invaild-audit-flow');
            }
        },
        // 檢查單據與金額
        async validateFileAmt() {
            // 總金額 和 單據金額不符 ( 非財務支出 )
            if (this.form.amt !== this.receiptAmtTotal && this.form.typ !== 6) {
                const FILES = _.chain(this.form.files)
                    .filter((o) => !o.delete)
                    .value();
                if (!FILES.length) {
                    return confirm.call(this, '請款單應有檢附單據，讓每筆帳都有憑有據。', '沒有檢附單據，確定要送出嗎？');
                }
                return confirm.call(this, '請款單的應付總額應要等於單據的總金額，才能讓每筆帳都乾淨正確。', '應付總額與單據總金額不符，確定要送出嗎？');
            }
            return true;
        },
        // 檢查請款單年份
        async validateYearDiff() {
            if (!this.isFullAuditFlow) {
                // 簡易流程，連動欄位
                // 預計付款日期 = 付款日期
                this.form.pdat = this.form.paY_DAT;
            }
            const datYear = new Date(this.form.dat).getFullYear();
            const pdatYear = new Date(this.form.pdat).getFullYear();

            if (datYear !== pdatYear) {
                return confirm.call(this, `請款單日期(${datYear}) 與付款日(${pdatYear}) 年份不同！確定要送出？`, '警告');
            }
            return true;
        },
        // 送出請款單資料
        submitPayment() {
            // 簡易流程，連動欄位
            if (!this.isFullAuditFlow) {
                // 實際付款方式 = 付款方式
                this.form.paY_WAY = this.form.useR_PAY_WAY;

                // 預計付款日期 = 付款日期
                this.form.pdat = this.form.paY_DAT;
            } else {
                // this.form.paY_CNYRAT = 0;
            }

            // 財務收支，連動欄位
            if (this.form.typ === 6) {
                // // 付款方式限定銀行付款
                // this.form.paY_WAY = 2;
                // this.form.useR_PAY_WAY = 2;

                // // 預計付款日期 = 付款日期
                // this.form.pdat = this.form.paY_DAT;

                // // 清空付款對象
                // this.form.vdR_SNO = null;
                // this.form.vdR_NAM = '';
                // this.form.vdR_BNK_TPC = '';
                // this.form.vdR_BNK_BOO = '';
                // this.form.vdR_BNK_DOO = '';
                // this.form.vdR_BNK_ACC = '';
                // this.form.vdR_FOREIGN = 0;
                // this.form.vdR_TEL = '';
                // this.form.vdR_EML = '';
                // this.form.paY_TO = null;
                // this.form.taX_CHK = false;
                // this.form.taX_AMT = 0;
                // this.form.taX_BNK_SNO = null;
                // this.form.taX_PAY_DAT = null;
                // this.form.geN2_CHK = false;
                // this.form.geN2_AMT = 0;
                // this.form.geN2_BNK_SNO = null;
                // this.form.geN2_PAY_DAT = null;

                if (this.variableProjectTyp === 0) this.form.poo = null;
            }

            // 補必填欄位（討論）
            if (!this.form.f_BSN) this.form.f_BSN = '';

            if (!this.form.f_NAM) this.form.f_NAM = '';

            // 境外身份
            if (this.form.abD_TYP === null) this.form.abD_TYP = 2;

            // 國際匯款
            if (this.form.typ === 5) {
                // 清空付款資訊
                this.form.vdR_SNO = null;
                this.form.vdR_NAM = '';
                this.form.vdR_BNK_TPC = this.form.paY_NAM; // 把收款人名同步填寫到戶名（for匯款明細用)
                this.form.vdR_BNK_BOO = '';
                this.form.vdR_BNK_DOO = '';
                this.form.vdR_BNK_ACC = '';
                this.form.vdR_BNK_NOTE = '';
                this.form.vdR_FOREIGN = 0;
                this.form.vdR_TEL = '';
                this.form.vdR_EML = '';
                this.form.taX_CHK = false;
                this.form.taX_AMT = 0;
                this.form.taX_BNK_SNO = null;
                this.form.taX_PAY_DAT = null;
                this.form.geN2_CHK = false;
                this.form.geN2_AMT = 0;
                this.form.geN2_BNK_SNO = null;
                this.form.geN2_PAY_DAT = null;
            }

            if (this.form.paY_TO !== 3) {
                this.form.geN2_CHK = false;
                this.form.geN2_AMT = 0;
                this.form.taX_CHK = false;
                this.form.taX_AMT = 0;
            }

            if (this.form.paY_WAY === 1) this.form.paY_BNK_SNO = null;

            if (this.form.serviceType === 1 || this.form.serviceType === 2) this.form.otherServiceType = null;
            else if (this.form.serviceType === 0) this.form.serviceSubType = null;
            else {
                this.form.serviceSubType = null;
                this.form.otherServiceType = null;
            }

            this.isSubmitting = true;

            this.$api({
                url: '/PaymentManagenmentPage/UpsertPayment',
                method: 'POST',
                data: {
                    ...this.form,
                    taX_BNK_SNO: this.form.taX_BNK_SNO === -1 ? null : this.form.taX_BNK_SNO,
                    geN2_BNK_SNO: this.form.geN2_BNK_SNO === -1 ? null : this.form.geN2_BNK_SNO,
                    taX_PAY_WAY: this.form.taX_BNK_SNO === -1 ? 1 : 2,
                    geN2_PAY_WAY: this.form.geN2_BNK_SNO === -1 ? 1 : 2,
                },
            })
                .then(async (resp) => {
                    // 檢查是否需要列印請款單
                    const isShowPrintTip = await this.checkIsShowPrintTip(resp.data.sno);
                    if (!isShowPrintTip) this.handleClose();
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        // 檢查是否需要列印請款單
        async checkIsShowPrintTip(sno) {
            if (this.companyInfo.isShowPrintTip) {
                try {
                    await this.$confirm('是否列印請款單', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                    });
                    this.$router.push({ name: 'payment-pdf', params: { sno } });
                    return true;
                } catch (e) {
                    console.log(e);
                    return false;
                }
            }
            return false;
        },

        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 變更專案，帶出專案已請款項目
        handleProjectChange() {
            const { poo } = this.form;

            this.currSpProjectDetail = null;
            this.isShowProjectPaymanetList = false;
            this.projectPayouts = [];

            if (!poo) return;

            // 專請款案
            if (this.form.typ === 2 || (this.variableProjectTyp === 2 && this.form.typ === 6)) {
                // 取得專案 sno
                const project = this.projectList.find((p) => p.poo === poo);
                if (project) {
                    // 取得專案資料
                    this.$api({
                        url: `PaymentManagenmentPage/GetProjectOptionDetail?SNO=${project.sno}`,
                        method: 'GET',
                    }).then((resp) => {
                        // 支出總額
                        const payoutTotal = _.chain(resp.data.detail.payouts)
                            .filter((o) => o.sigN_STS === 2 || o.sigN_STS === 3)
                            .sumBy((o) => o.amt * o.paY_CNYRAT)
                            .value();

                        // 支出百分比
                        let payoutPercent = null;
                        if (project.amT_PREOUT !== 0) {
                            payoutPercent = Math.round((payoutTotal / project.amT_PREOUT) * 100);
                        }

                        // 餘額
                        let payoutBalance = null;
                        if (project.amT_PREOUT !== 0) {
                            payoutBalance = project.amT_PREOUT - payoutTotal;
                        }

                        this.selectedProject = {
                            name: project.nam,
                            payoutMax: project.amT_PREOUT,
                            payoutTotal,
                            payoutPercent,
                            payoutBalance,
                            payouts: resp.data.detail.payouts, // 該專案已開請款單列表
                            auditFlowItems: null,
                            cny: project.cny,
                            customnumber: resp.data.detail.customnumber,
                            stF_SNO: resp.data.detail.stF_SNO,
                        };

                        this.projectPayouts = resp.data.detail.payouts;

                        // 自動帶入專案資訊
                        const PCN = resp.data.detail.customnumber;
                        if (!this.form.nam) {
                            this.form.nam = `${PCN || ''}${PCN ? '_' : ''}${project.nam}`;
                        }

                        // 設定幣別
                        if (project.cny !== 'TWD') {
                            // 外幣專案只能選 該外幣或台幣
                            this.availableCny = ['TWD', project.cny];

                            // 如果使用者已選其他幣別，則切換回專案幣別
                            if (!this.availableCny.includes(this.form.cny)) {
                                this.form.cny = project.cny;

                                if (this.form.amt) {
                                    this.$message({
                                        type: 'warning',
                                        message: `注意，幣別已切換為 ${this.form.cny}`,
                                    });
                                }
                            }
                        } else {
                            this.availableCny = null;
                        }
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: '無法取得專案資料。',
                        type: 'error',
                    });
                }
            }

            // 特定費用項目請款
            if (this.form.typ === 3 || (this.variableProjectTyp === 1 && this.form.typ === 6)) {
                // 取得特定費用項目 sno
                const spProject = this.specialProjectList.find((p) => p.poo === poo);
                if (spProject) {
                    // 取得特定費用項目資料
                    this.$api({
                        url: `PaymentManagenmentPage/GetProjectOptionDetail?SNO=${spProject.sno}`,
                        method: 'GET',
                    }).then((resp) => {
                        let payoutTotal = 0;
                        for (let i = 0; i < resp.data.detail.payouts.length; i += 1) {
                            if (resp.data.detail.payouts[i].sigN_STS === 3) {
                                payoutTotal += resp.data.detail.payouts[i].amt;
                            }
                        }

                        let payoutPercent = null;
                        if (spProject.amT_PREOUT !== 0) {
                            payoutPercent = Math.round((payoutTotal / spProject.amT_PREOUT) * 100);
                        }

                        let payoutBalance = null;
                        if (spProject.amT_PREOUT !== 0) {
                            payoutBalance = spProject.amT_PREOUT - payoutTotal;
                        }

                        this.selectedProject = {
                            name: spProject.nam,
                            payoutMax: spProject.amT_PREOUT,
                            payoutTotal,
                            payoutPercent,
                            payoutBalance,
                            payouts: resp.data.detail.payouts, // 該專案已開請款單列表
                            auditFlowItems: resp.data.detail.auditFlowItems,
                            cny: spProject.cny,
                        };

                        this.currSpProjectDetail = resp.data.detail;

                        // 帶入特定費用名稱到摘要
                        if (!this.form.nam) {
                            this.form.nam = this.selectedProject.name;
                        }

                        // 該特定費用項目已開請款單列表
                        this.projectPayouts = resp.data.detail.payouts;

                        // 設定幣別
                        if (spProject.cny !== 'TWD') {
                            // 外幣專案只能選 該外幣或台幣
                            this.availableCny = ['TWD', spProject.cny];

                            // 如果使用者已選其他幣別，則切換回專案幣別
                            if (!this.availableCny.includes(this.form.cny)) {
                                this.form.cny = spProject.cny;

                                if (this.form.amt) {
                                    this.$message({
                                        type: 'warning',
                                        message: `注意，幣別已切換為 ${this.form.cny}`,
                                    });
                                }
                            }
                        } else {
                            this.availableCny = null;
                        }
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: '無法取得專案資料。',
                        type: 'error',
                    });
                }
            }
        },

        handleProjectClear() {
            this.projectList = [];
        },

        // 經常性支出項目變更
        handleOftenProjectChange(sno) {
            // 取得經常性支出專案 sno
            const oftenProject = this.oftenProjectList.find((p) => p.sno === sno);

            if (oftenProject) {
                // 取得經常性支出資料
                this.$api({
                    url: `PaymentManagenmentPage/GetOftenOptionDetail?SNO=${oftenProject.sno}`,
                    method: 'GET',
                }).then((resp) => {
                    this.currOftenProjectDetail = resp.data.detail;

                    // 摘要預設同經常性名稱
                    this.form.nam = oftenProject.iteM_NAM;

                    // 清空已開請款單列表
                    this.projectPayouts = [];

                    // 設定幣別
                    this.form.cny = 'TWD';
                });
            } else {
                this.$message({
                    showClose: true,
                    message: '無法取得專案資料。',
                    type: 'error',
                });
            }
        },

        // 變更付款方式
        handlePayWayChange() {
            // 方式：銀行轉帳 & 對象：請款本人
            if (this.form.paY_TO === 1 && this.form.useR_PAY_WAY === 2) {
                this.setPayBankToStaffBank();
            }

            // 如果是零用現金，限定台幣
            if (this.form.useR_PAY_WAY === 1) {
                this.form.cny = 'TWD';
            }
        },

        /**
         * 變更付款對象
         * @param {number}  payToNum - 付款方式編號：1:公司員工, 2:委外廠商, 3:委外個人
         * @returns {void}
         */
        async handlePayToChange(payToNum) {
            this.temp.paY_TO = payToNum;

            // 清除付款對象相關欄位
            this.form.vdR_SNO = null;
            this.form.vdR_BNK_SNO = null;
            this.form.vdR_CNR_SNO = null;
            this.form.vdR_NAM = '';
            this.form.vdR_BNK_TPC = '';
            this.form.vdR_BNK_BOO = '';
            this.form.vdR_BNK_DOO = '';
            this.form.vdR_BNK_ACC = '';
            this.form.vdR_BNK_NOTE = '';
            this.form.vdR_FOREIGN = 0;
            this.form.vdR_TEL = '';
            this.form.vdR_EML = '';
            this.form.paY_STF_SNO = null;

            if (this.form.paY_TO !== 3) {
                this.form.taX_CHK = false;
                this.form.taX_AMT = 0;
                this.form.geN2_CHK = false;
                this.form.geN2_AMT = 0;
            }

            // 對象：公司員工
            if (payToNum === 1) {
                this.isLoadingStaffList = true;
                this.employeeList = await fetchAllEmployee();
                this.isLoadingStaffList = false;

                // 如還未選擇，則預選員工自己
                if (!this.form.paY_STF_SNO) {
                    const staff = _.find(this.employeeList, ['staff_SNO', this.userSno]);
                    if (staff) {
                        this.form.paY_STF_SNO = staff.staff_SNO;
                        this.form.vdR_BNK_BOO = staff.stafF_BNK_BOO;
                        this.form.vdR_BNK_DOO = staff.stafF_BNK_DOO;
                        this.form.vdR_BNK_ACC = staff.stafF_BNK_ACC;
                        this.form.vdR_BNK_TPC = staff.stafF_BNK_TPC;
                        this.form.vdR_BNK_NOTE = null;
                        this.staffTyp = staff.typ;
                    }
                }
            }

            // 對象：委外廠商
            if (this.form.paY_TO === 2) {
                // 如果設定為顯示全部廠商，則載入列表
                if (this.companyInfo.displayVendorOutsource) {
                    this.vendorList = await getAllOutsourcingCompany();
                }
            }

            // 對象：委外個人
            if (this.form.paY_TO === 3) {
                // 如果設定為顯示全部廠商，則載入列表
                if (this.companyInfo.displayPersonalOutsource) {
                    this.outsourcingList = await getAllOutsourcingPerson();
                }
            }

            // 更新勞務代扣計算
            this.initTaxInfo();
        },

        /**
         * 變更公司員工
         * @param {number}  sno - 公司員工編號
         * @returns {void}
         */
        async handleStaffChange(sno) {
            this.applyStaffPayInfos(sno);
        },

        /**
         * 變更委外廠商
         * @param {number}  sno - 委外廠商編號
         * @returns {void}
         */
        async handleOursourcingCompanyChange(sno) {
            this.applyOutsourcingCompany(sno);
        },

        /**
         * 變更委外個人
         * @param {number}  sno - 委外個人編號
         * @returns {void}
         */
        async handleOutsourcingPersonChange(sno) {
            this.applyOutsourcingPerson(sno);
        },

        /**
         * 載入公司員工
         * @param {number}  sno - 公司員工sno
         * @param {number}  desireBnkSno - 預選帳戶編號
         * @param {number}  overwriteList - 複寫回委外個人列表
         * @returns {void}
         */
        async applyStaffPayInfos(sno, overwriteList = false) {
            this.isLoadingStaffData = true;
            const staffData = await getStaffBySno(sno);
            this.isLoadingStaffData = false;
            if (staffData) {
                this.form.paY_STF_SNO = staffData.staff_SNO;

                // 重新放回委外個人下拉列表
                if (overwriteList) {
                    this.employeeList = [staffData];
                }

                // 清空帳戶列表（公司員工無多帳戶）
                this.vdrBankList = [];

                // 清空聯絡人列表（公司員工無聯絡人）
                this.vdrContactList = [];

                // 放入付款相關資料
                this.form.vdR_BNK_BOO = staffData.stafF_BNK_BOO;
                this.form.vdR_BNK_DOO = staffData.stafF_BNK_DOO;
                this.form.vdR_BNK_ACC = staffData.stafF_BNK_ACC;
                this.form.vdR_BNK_TPC = staffData.stafF_BNK_TPC;
                this.form.vdR_BNK_NOTE = null;
                this.staffTyp = staffData.typ;
            }
        },

        /**
         * 載入委外廠商資料、帳戶列表、聯絡人列表
         * @param {number}  sno - 委外廠商編號
         * @param {number}  desireBnkSno - 預選帳戶編號
         * @param {number}  desireContactSno - 預選聯絡人編號
         * @param {number}  overwriteList - 複寫回委外廠商列表
         * @returns {void}
         */
        async applyOutsourcingCompany(sno, desireBnkSno = null, desireContactSno = null, overwriteList = false) {
            const companyData = await getOutsourcingCompanyBySno(sno);
            if (companyData) {
                console.log('companyData', companyData);
                this.form.vdR_SNO = companyData.sno;
                this.form.abd = companyData.abd;

                // 重新放回委外廠商下拉列表
                if (overwriteList) {
                    this.vendorList = [companyData];
                }

                // 載入廠商帳戶列表
                this.vdrBankList = companyData.vendorBanks || [];

                // 載入廠商聯絡人列表
                this.vdrContactList = companyData.vendorContacts || [];

                // 選擇指定廠商帳戶、或選擇第一筆
                if (desireBnkSno) {
                    // 確認指定帳戶存在
                    const desireBnk = this.vdrBankList.find((b) => b.sno === desireBnkSno);
                    if (desireBnk) {
                        this.form.vdR_BNK_SNO = desireBnkSno;
                        this.fillVendorTransferInfo(desireBnkSno); // 填入相關欄位資料
                    }
                } else {
                    const firstItem = _.head(this.vdrBankList);
                    if (firstItem) {
                        this.form.vdR_BNK_SNO = firstItem.sno;
                        this.fillVendorTransferInfo(firstItem.sno); // 填入相關欄位資料
                    }
                }

                // 選擇指定廠商聯絡人、或選擇第一筆
                if (desireContactSno) {
                    // 確認指定聯絡人存在
                    const desireContact = this.vdrContactList.find((b) => b.sno === desireContactSno);
                    if (desireContact) {
                        this.form.vdR_CNR_SNO = desireContactSno;
                        this.fillVendorContactInfo(desireContactSno);
                    }
                } else {
                    const firstItem = _.head(this.vdrContactList);
                    if (firstItem) {
                        this.form.vdR_CNR_SNO = firstItem.sno;
                        this.fillVendorContactInfo(firstItem.sno);
                    }
                }
            }
        },

        /**
         * 載入委外個人資料、帳戶列表
         * @param {number}  sno - 委外個人編號
         * @param {number}  desireBnkSno - 預選帳戶編號
         * @param {number}  overwriteList - 複寫回委外個人列表
         * @returns {void}
         */
        async applyOutsourcingPerson(sno, desireBnkSno = null, overwriteList = false) {
            const personData = await getOutsourcingPersonBySno(sno);
            if (personData) {
                this.form.vdR_SNO = personData.sno;
                this.form.abd = personData.abd; // 國籍 0=本國籍, 1=外國籍(在台已滿183天) 2=外國籍(在台未滿183天)
                this.form.abD_TYP = personData.abD_TYP;

                // 重新放回委外個人下拉列表
                if (overwriteList) {
                    this.outsourcingList = [personData];
                }

                // 載入帳戶列表
                this.vdrBankList = personData.vendorBanks || [];

                // 載入聯絡人列表（委外個人只有一個聯絡人）
                this.vdrContactList = personData.vendorContacts || [];

                // 選擇指定廠商帳戶、或選擇第一筆
                if (desireBnkSno) {
                    // 確認指定帳戶存在
                    const desireBnk = this.vdrBankList.find((b) => b.sno === desireBnkSno);
                    if (desireBnk) {
                        this.form.vdR_BNK_SNO = desireBnkSno;
                        this.fillVendorTransferInfo(desireBnkSno); // 填入相關欄位資料
                    }
                } else {
                    const firstItem = _.head(this.vdrBankList);
                    if (firstItem) {
                        this.form.vdR_BNK_SNO = firstItem.sno;
                        this.fillVendorTransferInfo(firstItem.sno); // 填入相關欄位資料
                    }
                }

                // 填入聯絡資料
                this.form.vdR_NAM = personData.fnam; // 直接使用姓名
                const contact = _.head(personData.vendorContacts);
                if (contact) {
                    this.form.vdR_TEL = contact.ext ? `${contact.tel} #${contact.ext}` : contact.tel;
                    this.form.vdR_EML = contact.eml;
                }
            }
        },

        fillVendorInfo() {
            const outsourcingList = this.form.paY_TO === 2 ? this.vendorList : this.outsourcingList;
            const vdr = outsourcingList.find((o) => o.sno === this.form.vdR_SNO);

            this.form.abd = vdr.abd; // 國籍 0=本國籍, 1=外國籍(在台已滿183天) 2=外國籍(在台未滿183天)
            this.form.abD_TYP = vdr.abD_TYP; // 證件號碼類型： 1= 個人身分證 2=營業統一編號
            // 讓檢附單據視窗可預填廠商資訊
            this.selectedVendorBsn = vdr.bsn;
            this.selectedVendorName = vdr.fnam;

            if (vdr.vendorContacts && vdr.vendorContacts.length === 1) {
                const contact = vdr.vendorContacts[0];
                this.form.vdR_NAM = contact.nam;
                this.form.vdR_TEL = contact.tel;
                this.form.vdR_EML = contact.eml;

                if (!contact.nam) {
                    this.form.vdR_NAM = vdr.fnam;
                }
            }
        },
        fillVendorTransferInfo(sno) {
            const vdrBnk = this.vdrBankList.find((o) => o.sno === sno);
            if (vdrBnk) {
                console.log('vdrBnk', vdrBnk);
                this.form.accountType = vdrBnk.accountType; // 帳戶類型
                this.form.vdR_BNK_TPC = vdrBnk.bnK_TPC;
                this.form.vdR_BNK_BOO = vdrBnk.bnK_BOO;
                this.form.vdR_BNK_DOO = vdrBnk.bnK_DOO;
                this.form.vdR_BNK_ACC = vdrBnk.bnK_ACC;
                this.form.vdR_BNK_NOTE = vdrBnk.note;
                this.form.abroadBankName = vdrBnk.abroadBankName; // 境外銀行
                this.form.swiftCode = vdrBnk.swiftCode; // 境外swift code

                // 載入分行選項
                if (vdrBnk.bnK_BOO) {
                    this.fetchBranchList(vdrBnk.bnK_BOO);
                }
            } else {
                console.error('找不到委外銀行帳戶 sno=', sno);
            }
        },
        fillVendorContactInfo(sno) {
            const vdrBnk = this.vdrContactList.find((o) => o.sno === sno);
            if (vdrBnk) {
                this.form.vdR_NAM = vdrBnk.nam;
                this.form.vdR_TEL = vdrBnk.tel;
                this.form.vdR_EML = vdrBnk.eml;
            } else {
                console.error('找不到委外聯絡人 sno=', sno);
            }
        },
        resetVendorInfo() {
            this.form.abd = null;
            this.form.abD_TYP = null;
            this.form.abroadBankName = null;
            this.form.swiftCode = null;
            this.form.vdR_BNK_TPC = null;
            this.form.vdR_BNK_BOO = null;
            this.form.vdR_BNK_DOO = null;
            this.form.vdR_BNK_ACC = null;
            this.form.vdR_BNK_NOTE = null;
            this.form.vdR_NAM = null;
            this.form.vdR_TEL = null;
            this.form.vdR_EML = null;
        },
        handleAgreeFileSuccess(res) {
            this.form.vdR_FILE_AGREE = res.imgUrl;
        },
        handleInvoiceFileSuccess(res) {
            this.form.filE_ATT = res.imgUrl;
        },

        async handleDelete() {
            try {
                await this.$confirm('確定要刪除這筆請款嗎？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/PaymentManagenmentPage/DeletePaymentInfo',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                });
                this.handleClose();
            } catch (e) {
                console.log(e);
            }
        },

        // 檢附檔案-編輯
        handleFileEditBtnClick(index) {
            this.activeFileIndex = index;
            this.attachFileDialogVisibility = true;
        },

        // 檢附檔案-刪除
        handleFileDeleteBtnClick(index) {
            const file = this.form.files[index];
            if (file) {
                if (file.sno) {
                    // 檔案已存在（編輯模式），標記為刪除
                    file.delete = true;
                } else {
                    // 新增模式，直接刪除
                    this.form.files.splice(index, 1);
                }
            }
        },

        setPayBankToStaffBank() {
            const STAFF = _.find(this.employeeList, ['staff_SNO', this.form.paY_STF_SNO]);
            this.form.vdR_BNK_BOO = STAFF.stafF_BNK_BOO;
            this.form.vdR_BNK_DOO = STAFF.stafF_BNK_DOO;
            this.form.vdR_BNK_ACC = STAFF.stafF_BNK_ACC;
            this.form.vdR_BNK_TPC = STAFF.stafF_BNK_TPC;
            this.form.vdR_BNK_NOTE = null;
            this.staffTyp = STAFF.typ;
        },

        getCnyRat(cny) {
            const cnyOption = this.cnyOptions.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        applySysCnyRat(cny) {
            const cnyOption = this.cnyOptions.find((x) => x.cny === cny);
            if (cnyOption) {
                this.form.paY_CNYRAT = cnyOption.rat;
                this.onCnyRatChange();
            } else {
                alert(`找不到該幣別資料：${cny}`);
            }
        },
        fetchPdat() {
            if (!this.companyInfo.payouT_PDAT) return;
            const payoutPdat = moment().date(this.companyInfo.payouT_PDAT);
            if (moment().isAfter(payoutPdat)) payoutPdat.add(1, 'month');
            this.form.pdat = Number(payoutPdat.format('x'));
        },
        onChangeServiceType(val) {
            // 選擇勞務所得類別時，清除執行業務所得、其他業務說明欄
            this.form.serviceSubType = null;
            this.form.otherServiceType = null;
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });

            this.tax_ratio = val === 3 ? 5 : 10;
            this.gen2_ratio = 2.11;

            this.initTaxInfo();
        },
        async copyFromSno(sno, receiptSnoList) {
            // 載入來源請款單資料
            const resp = await this.$api({
                url: `/PaymentManagenmentPage/GetPaymentInfo?Sno=${sno}`,
                method: 'GET',
            });

            const source = resp.data.item;

            if (source) {
                // 複製欄位
                const copyProps = [
                    // 'dat',
                    'typ',
                    'nam',
                    'cny',
                    'amt',
                    'useR_PAY_WAY',
                    // 'pdat',
                    // 'paY_DAT',
                    'paY_TO',
                    'paY_NAM',
                    'paY_COUNRTY',
                    // 'paY_STF_SNO', // 有條件
                    // 'paY_BNK_SNO',
                    // 'paY_CNYRAT',
                    'poo',
                    'ofeN_ITEM_SNO',
                    'abd',
                    'abD_TYP',
                    // 'abroadBankName', // 不複製，使用最新資料
                    // 'swiftCode', // 不複製，使用最新資料
                    // 'vdR_SNO', // 有條件
                    // 'vdR_BNK_SNO', // 有條件
                    // 'vdR_CNR_SNO', // 有條件
                    // 'vdR_BNK_BOO', // 不複製，使用最新資料
                    // 'vdR_BNK_DOO', // 不複製，使用最新資料
                    // 'vdR_BNK_ACC', // 不複製，使用最新資料
                    // 'vdR_BNK_TPC', // 不複製，使用最新資料
                    // 'vdR_BNK_NOTE', // 不複製，使用最新資料
                    'vdR_FILE_AGREE',
                    // 'vdR_NAM', // 不複製，使用最新資料
                    // 'vdR_TEL', // 不複製，使用最新資料
                    // 'vdR_EML', // 不複製，使用最新資料
                    // 'files', // 下方獨立處理
                    // 'toBeAddFile',
                    'oS_MEM',
                    'serviceType',
                    'serviceSubType',
                    'otherServiceType',
                    'taX_CHK',
                    'taX_AMT',
                    'taX_PAY_WAY',
                    // 'taX_BNK_SNO',
                    // 'taX_PAY_DAT',
                    'geN2_CHK',
                    'geN2_AMT',
                    'geN2_PAY_WAY',
                    // 'geN2_BNK_SNO',
                    // 'geN2_PAY_DAT',
                    'iteM_SNO',
                    'accno',
                    'clearanceAccno',
                ];

                // 有條件複製欄位
                // 對象：公司員工
                if (source.paY_TO === 1) {
                    copyProps.push('paY_STF_SNO');
                }
                // 對象：委外廠商
                if (source.paY_TO === 2) {
                    copyProps.push('vdR_SNO');
                    copyProps.push('vdR_BNK_SNO');
                    copyProps.push('vdR_CNR_SNO');
                }
                // 對象：委外個人
                if (source.paY_TO === 3) {
                    copyProps.push('vdR_SNO');
                    copyProps.push('vdR_BNK_SNO');
                }

                // 自訂流程：如果來源單是銀行提現，改為銀行轉帳，因為銀行提現是用銀行轉帳時，付款階段才能選擇的項目
                if (this.isFullAuditFlow && source.useR_PAY_WAY === 3) {
                    source.useR_PAY_WAY = 2;
                }

                // 複製欄位資料
                _.forEach(copyProps, (key) => {
                    this.form[key] = source[key];
                });

                // 複製單據
                if (receiptSnoList && receiptSnoList.length > 0) {
                    source.files.forEach((file) => {
                        if (receiptSnoList.indexOf(file.sno) !== -1) {
                            this.form.files.push({
                                foo: file.foo,
                                foO_DAT: file.foO_DAT,
                                bsn: file.bsn,
                                filE_TYP: file.filE_TYP,
                                filE_ATT: file.filE_ATT,
                                companyName: file.companyName,
                                tax: file.tax,
                                note: file.note,
                                amt: file.amt,
                                code: null,
                                delete: false,
                                prefiX_MONTH: null,
                                prefiX_YER: null,
                            });
                        }
                    });
                }

                // 外幣匯率更新
                if (this.form.cny !== 'TWD') {
                    this.applySysCnyRat(this.form.cny);
                }

                if (source.typ === 6) {
                    if (source.poo?.includes('PJ')) this.variableProjectTyp = 2;
                    else if (source.poo?.includes('SP')) this.variableProjectTyp = 1;
                }
            }
        },
        getVendorBankLabel(bankItem) {
            if (bankItem.note) {
                return `${bankItem.bnK_TPC || ''} (${bankItem.note}) - (${bankItem.bnK_BOO || ''})${bankItem.bnK_ACC || ''}`;
            }
            return `${bankItem.bnK_TPC || ''} - (${bankItem.bnK_BOO || ''})${bankItem.bnK_ACC || ''}`;
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded() {
            this.isAhSuggestAccountingItemsSelectorShow = this.isPayed('G01') || this.$store.getters['account/isSAAdmin'];
        },
        onNamInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
        onVariableProjectTypChange() {
            this.form.poo = null;
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.payment-edit-page {
    .ah-panel {
        margin-bottom: 40px;

        .panel-title {
        }
    }
    .section-block {
        border: 2px solid #ddd;
        border-radius: 8px;
        padding: 20px 30px;
        margin-bottom: 20px;
    }

    .total {
        font-size: 16pt;
        font-weight: bold;
        text-align: right;
        padding: 0 50px 0 0;
    }

    .audit-steps {
        max-width: 750px;
        margin: 20px auto;
        color: red;

        .el-step__title.is-wait,
        .el-step__description.is-wait {
            color: #666;
        }

        .el-step__title.is-wait {
            font-size: 11pt;
        }
    }

    .project-select {
        width: 100%;

        .el-input__inner {
            color: #463cb2 !important;
        }
    }

    .selected-project-info.ah-card {
        margin-top: 12px;
        line-height: initial;

        .project-type {
            font-size: 10pt;
            margin-right: 10px;
            line-height: initial;
            font-size: 10pt;
            color: #aaa;
            border: 1px solid #ccc;
            padding: 2px 6px;
            border-radius: 5px;
        }

        .content {
            .statis-title {
                font-size: 10pt;
                margin-bottom: 5px;
                color: #666;
                font-weight: normal !important;
            }
        }

        .selected-project-payouts-table {
            border-radius: 5px;
            overflow: hidden;
            border: 1px solid #666;

            .el-table__header {
                margin-bottom: 0;

                th {
                    padding: 2px 0;
                    background-color: #666;
                    color: #fff;
                }
            }
        }
    }

    .auditFlow-table {
        th {
            padding: 0;
        }
    }

    .attachment-card {
        margin: 0 0 10px 0;
        padding: 15px;
        background-color: #f6f6f6;
        border-radius: 10px;

        table {
            line-height: 20pt;

            th {
                text-align: right;
            }
        }
    }
    .date-warning {
        font-size: 9pt;
        color: rgb(255, 119, 0);
    }
    .service-type-note {
        width: 100%;
        height: 100%;
        line-height: 150%;
        font-size: 10pt;
        color: #9e5f00;
        background-color: #fdf6ec;
        padding: 15px 15px;
        border-radius: 6px;

        .name {
            font-weight: bold;
            margin-top: 10px;
            padding: 0 0 0 25px;
        }

        ol {
            li {
                margin-bottom: 5px;
            }
        }
    }

    .payInfoModifyWarning {
        margin: 0 10px 10px 10px;
        border: 1px solid #e6a23c44;
        padding-top: 5px;

        .el-alert__description {
            font-weight: bold;
            font-size: 10pt;
        }
    }

    .secondary-block {
        padding: 25px 25px;
        background-color: #f6f6f6;
        border-radius: 10px;
    }
}
.el-select-dropdown__item.payment-account-item {
    padding-top: 3px;
    height: 60px;
    line-height: 15px;

    .main {
        display: block;

        .name {
            float: left;
            padding-top: 0px;
            height: 28px;
        }

        .dep {
            float: right;
            margin-left: 10px;
            font-size: 9pt;
            font-weight: normal;
            color: #bbb;
        }
    }

    .sub {
        .email {
            position: relative;
            top: -5px;
            font-size: 9pt;
            color: #ccc;
            height: 15px;
            line-height: 15px;
            font-weight: normal;
        }
    }

    .clearfix:before,
    .clearfix:after {
        content: "";
        display: table;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        *zoom: 1;
        /*For IE 6&7 only*/
    }
}

.el-select-dropdown__item.vendor-transfer-item {
    padding: 10px 15px 10px 15px;
    height: 80px;
    line-height: 20px;

    .account-name {
        display: block;
    }

    .account-number {
        display: block;
    }

    .account-note {
        position: relative;
        font-size: 9pt;
        color: #aaa;
        font-weight: normal;
    }
}

.tax-layout {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 40px;

    @media (min-width: 1024px) {
        flex-direction: row;
    }

    > .forms {
        flex-grow: 1;
    }
    > .rules {
        flex-grow: 1;
        max-width: 500px;
    }
}

.amt-with-twd {
    display: flex;
    flex-direction: column;

    .twd {
        margin-top: -5px;
        font-size: 9pt;
        color: #999;
        .money {
            font-weight: normal;
        }
    }
}
.tax-hr {
    margin: 30px 0;
}
</style>
